require('./type/thirdweb.type')
const EventEmitter = require('events')
const {promisify} = require('util')
const url = require('url')
const rpc = require('json-rpc2')
const hazama = require('hazama-core')
const bitcoin = require('bitcoinjs-lib')
const fs = require('fs')
const messages = require('./constant/messages')
const {ThirdwebSDK, DEFAULT_QUERY_ALL_COUNT, REMOTE_CONTRACT_TO_CONTRACT_TYPE} = require('@thirdweb-dev/sdk')
const TokenType = require("./constant/token-type")
const getRpcUrlsByNetWork = require("./constant/network-info").getRpcUrlsByNetWork
const ethers = require('ethers')
const { isArray, isArrayFull } = require('./utils/common')

/**
 * Library for Hazama base platform
 * @namespace 
 * @name hazama-lib
 */
const lib = new EventEmitter()
lib.on('error', (err) => {
  const message = err.message

  if (message.includes("transaction underpriced")) {
    throw new Error(message.TRAMSACTIONUNDERPRICED)
  }
  else if (message.includes("exceeded-max-quantity")) {
    throw new Error(message.EXCEEDEDMAXQUANTITY)
  }
  else if (message.includes("word mismatch")) {
    throw new Error(message.WORDMISMATCH)
  }
  else if (message.toLowerCase().includes("user rejected transaction")) {
    throw new Error(message.USERDENIEDTRANSACTION)
  }
  else if (message.includes("User denied transaction signature") || message.includes("User denied message signature")) {
    throw new Error(message.USERDENIEDTRANSACTION)
  }
  else if (message.includes("execution-only-allowed-by-owner")) {
    throw new Error(message.EXECUTIONONLYALLOWEDBYOWNER)
  }
  else if (message.includes("insufficient funds for gas * price + value")) {
    throw new Error(message.INSUFFICIENTFUNDSFORGAS)
  }
  else if (message.includes("is not a valid address") ) {
    throw new Error(message.WLINVALIDADDRESS)
  }
  else if (message.includes("Need help with this error")) {
    throw new Error(messages.NEED_HELP)
  }
  else {
    throw(err)
  }
});

let currentClient
let currentConnection
let generalServerInfo
let hazNetworkSetupManually = false

function isAbiCompatible(abi, entrypoints) {
  return abi.reduce((p, x) => p && (x in entrypoints), true)
}

lib.connect = (endpoint, cb) => {
  let endpointData = url.parse(endpoint)

  let user
  let pass

  if (endpointData.auth) {
    [user, pass] = endpointData.auth.split(':')
  }

  let connectHost
  if (endpointData.hostname) {
    connectHost = endpointData.hostname
  } else {
    connectHost = endpointData.pathname
  }

  let connectPort
  if (endpointData.port) {
    connectPort = parseInt(endpointData.port)
  } else {
    if (endpointData.protocol === 'wss:' || endpointData.protocol === 'https:') {
      connectPort = 443
    } else {
      connectPort = 80
    }
  }
  const client = (typeof window !== 'undefined')? { host: connectHost, connectWebsocket: () => {}, expose: () => {} }: rpc.Client.$create(connectPort, connectHost, user, pass)
  if (endpointData.protocol === 'wss:' || endpointData.protocol === 'https:') {
    console.log('wss://' + client.host + ':443' + endpointData.path)
  }
  client.host = endpointData.href
  
  let connectWebsocket = client.connectWebsocket

  const connector = async (err, result) => {
    if (err) {
      throw err
    } else if (!result) {
      throw new Error('Couldn\'t connect to endpoint')
    } else {
      currentConnection = result
      currentConnection.callAsync = promisify(currentConnection.call)
      currentClient = client
  
      let info = await currentConnection.callAsync('core.info', [])
      if (info.network) {
        generalServerInfo = info
        hazama.networks.mainnet = info.network
        if (hazNetworkSetupManually) {
          setNetworkDeprecationNotice()
        }
      }
  
      if (cb) cb()
  
      lib.watch('\\/_\\/block\\..*', (k) => {
        lib.emit('new block', k)
      })
  
      lib.watch('\\/_\\/tx\\..*', (k) => {
        lib.emit('new tx', k)
      })
  
      currentClient.expose('event', ([key]) => {
        lib.emit('_raw_event', key)
      })
  
      currentClient.expose('verifyevent', ([msg]) => {
        lib.emit('_verify_event', msg)
      })
      
      currentConnection.on('close', () => {
        currentConnection = null
        lib.emit('close')
      })
      
      lib.emit('connected', currentConnection)
    }
  }
  if( typeof window !== 'undefined' ) {
    let lastId = 0
    let sendMsg
    let waitCbs = {}
    
    const connectWebsocket = (connector) => {
      let socket = new WebSocket(client.host)
      socket.addEventListener('open', () => {
        console.log('open', client.host)
        sendMsg = (method, params, cb) => {
          let ob = {
            jsonrpc: '2.0',
            id: lastId,
            method, params
          }
          waitCbs[lastId] = {cb, ts: Date.now(), method, ob}
          socket.send(JSON.stringify(ob))
          lastId++
        }
        
        socket.addEventListener('message', (event) => {
          let ob
          try {
            ob = JSON.parse(event.data)
          } catch (e) {
            ob = null
          }
          
          if (ob) {
            if ('id' in ob && ob.id in waitCbs) {
              if (!ob.error) {
                waitCbs[ob.id].cb(null, ob.result)
              } else {
                waitCbs[ob.id].cb(ob.error)
              }
        
              delete waitCbs[ob.id]
            } else if ('method' in ob && ob.method === 'event') {
              lib.emit('_raw_event', ob.params[0])
            }
          }
        })
        
        socket.addEventListener('close', () => {
          console.log('closed', client.host)
          lib.emit('close')
        })
        
        socket.on = (e, cb) => {
          socket.addEventListener(e, cb)
        }
        
        socket.end = () => {
          socket.close()
        }
        
        const call = (method, params, callback) => {
          sendMsg(method, params, (error, data) => {
            if (error) {
              callback(error, null)
            } else {
              callback(null, data)
            }
          })
        }
        socket.call = call
        
        connector(null, socket)
      })
    }
    client.connectWebsocket = connectWebsocket
  }
  
  if( currentConnection != null ) return cb()
  
  client.connectWebsocket(connector)
}

function setNetworkDeprecationNotice() {
  console.log('Deprecation notice: hazlib.setNetwork() isn\'t necessary on this server instance')
}

lib.reconnect = () => {
  currentClient.connectWebsocket(async (err, result) => {
    if (err) {
      throw err
    } else if (!result) {
      throw new Error('Couldn\'t connect to endpoint')
    } else {
      currentConnection = result
      currentConnection.callAsync = promisify(currentConnection.call)
      
      let info = await currentConnection.callAsync('core.info', [])
      if (info.network) {
        generalServerInfo = info
        hazama.networks.mainnet = info.network
        if (hazNetworkSetupManually) {
          setNetworkDeprecationNotice()
        }
      }

      lib.emit('connected', result)

      currentConnection.on('close', () => {
        currentConnection = null
        lib.emit('close')
      })
    }
  })
}

lib.setNetwork = (network) => {
  if (generalServerInfo) {
    setNetworkDeprecationNotice()
  } else {
    hazNetworkSetupManually = true
    hazama.networks.mainnet = network
  }
}

lib.compile = (code) => {
  return hazama.asm.compile(code)
}

lib.envelope = (bytecode, wif) => {
  if (typeof(bytecode) === 'string') {
    bytecode = Buffer.from(bytecode, 'hex')
  }

  const ecpair = bitcoin.ECPair.fromWIF(wif)
  return hazama.buildEnvelope(ecpair, bytecode)
}

lib.envelopeWithWallet = async (bytecode, signer) => {
  if (typeof(bytecode) === 'string') {
    bytecode = Buffer.from(bytecode, 'hex')
  }

  return await hazama.buildEnvelopeWithWallet(signer, bytecode)
}

lib.template = (name, params) => {
  return currentConnection.callAsync('core.template', [name, params])
}

lib.get = (key) => {
  return currentConnection.callAsync('core.get', [key])
}

lib.iterate = async (options, amount) => {
  let iterId = await currentConnection.callAsync('core.inititerator', [options])
  let finished = false
  let next = async () => {
    if (finished) {
      return null
    } else {
      let response = await currentConnection.callAsync('core.fetchiterator', [iterId, amount])
      if (response) {
        let { hadValues, res: results } = response

        if (!hadValues) { //(!results/*.length < amount*/) {
          finished = true
        }

        return results
      } else {
        finished = true
        return null
      }
    }
  }

  return next
}

lib.tx = (data) => {
  if (Buffer.isBuffer(data)) {
    data = data.toString('hex')
  }

  return currentConnection.callAsync('core.tx', [data])
}

lib.txwithoutmempool = (data) => {
  if (Buffer.isBuffer(data)) {
    data = data.toString('hex')
  }

  return currentConnection.callAsync('core.txwithoutmempool', [data])
}

lib.block = (data) => {
  if (Buffer.isBuffer(data)) {
    data = data.toString('hex')
  }

  return currentConnection.callAsync('core.block', [data])
}

lib.watch = (regex, handler) => {
  const r = new RegExp(regex)
  lib.on('_raw_event', (key) => {
    if (r.test(key)) {
      handler(key)
    }
  })
  currentConnection.callAsync('core.subscribe', [regex])
}

lib.verifyEvents = (handler) => {
  lib.on('_verify_event', (msg) => {
    handler(msg)
  })
  currentConnection.callAsync('core.verifyevents', [])
}

lib.createWallet = () => {
  const ecpair = bitcoin.ECPair.makeRandom()
  let network = hazama.networks.mainnet
  const { address } = bitcoin.payments.p2pkh({ pubkey: ecpair.publicKey, network: network })

  return { address, wif: ecpair.toWIF(), ecpair }
}

lib.walletFromWif = (wif) => {
  const ecpair = bitcoin.ECPair.fromWIF(wif)
  let network = hazama.networks.mainnet
  const { address } = bitcoin.payments.p2pkh({ pubkey: ecpair.publicKey, network: network })

  return { address, wif: ecpair.toWIF(), ecpair }
}

lib.decodeCall = (envelope) => {
  let msg = hazama.openEnvelope(Buffer.from(envelope, 'hex'))
  let lines = hazama.asm.unpack(msg.data).filter(x => x.opName !== 'NOOP' && x.opName !== 'END' && x.opName !== 'REQUIRE')
  let calls = []
  let params = []
  for (let i=0; i < lines.length; i++) {
    let item = lines[i]
    if (item.opName.startsWith('PUSH')) {
      params.push(item.params[0])
    } else if (item.opName === 'ECALL') {
      calls.push({ [item.params[0]]: params })
      params = []
    }
  }
  return {from: msg.from, calls}
}

lib.makeFileFormat = (filename, cb) => {
  if ((typeof(process) !== 'undefined') && process.mainModule && process.mainModule.path) {
    let filetype = require('file-type')
    try {
      let path = require('path')
      let fname = process.mainModule.path + path.sep + filename
  
      fs.accessSync(fname, fs.constants.R_OK)
      fs.readFile(filename, 'base64', async (err, data) => {
        if( err ) return cb(err, null)
        
        const fileType = await filetype.fromFile(fname)
        if( !fileType ) return cb(new Error(`${filename} is an unsupported`), null)
        
        let dataFormat = {}
        dataFormat.size = data.length
        dataFormat.mime = fileType.mime
        dataFormat.ext = fileType.ext
        for (let i = 0; ; i++) {
          let split_data = data.substr(i * 50000, 50000)
          if( split_data.length <= 0 ) break
          dataFormat[fileType.mime + ((i > 0)? `/${i}`: '')] = split_data
        }
        
        cb(null, dataFormat)
      })
    } catch (e) {
      cb(e, null)
    }
  }
}

function getBase64(data) {
  let base64data = ''
  if( !data.mime ) throw new Error('file format not found')
  
  for( let i = 0; ; i++ ) {
    let key = data.mime + ((i > 0)? `/${i}`: '')
    if( !(key in data) ) break
    base64data += data[key]
  }
  
  if( base64data.length <= 0 ) throw new Error('empty file')
  
  return base64data
}

lib.getFileBase64 = (data) => {
  return getBase64(data)
}

lib.getFileBuffer = (data) => {
  return Buffer.from(getBase64(data), 'base64')
}

lib.waitBlock = () => new Promise((resolve) => {
  lib.once('new block', () => {
    setTimeout(resolve, 10) // Needs a tiny bit of wait
  })
})

lib.waitTx = (txid) => new Promise((resolve) => {
  let watcher = (k) => {
    if (k.indexOf(txid) >= 0) {
      resolve(k)
    }
    lib.removeListener('new tx', watcher)
  }
  lib.on('new tx', watcher)
})

lib.waitMinedTx = (txid) => new Promise(async (resolve) => {
  let blockWatcher = async () => {
    let res = await lib.get(`/_/tx.${txid}.feds`)

    if (res) {
      let mined = Object.entries(res)
        .map(([k, v]) => v !== null && v.length > 0) // Check if it's mined by this each fed
        .reduce((p, x) => p && x, true) // All feds should be true to get it mined
      if (mined) {
        //lib.removeListener('new block', blockWatcher)
        resolve(txid)
      }
    }
  }

  let watcher = async (k) => {
    if (k.indexOf(txid) >= 0) {
      lib.on('new block', blockWatcher)
      
      let alreadyThere = await lib.get(`/_/tx.${txid}.block`)
      if( alreadyThere !== null ) {
        blockWatcher()
      }
    }
    //lib.removeListener('new tx', watcher)
  }
  lib.on('new tx', watcher)

  let alreadyThere = await lib.get(`/_/tx.${txid}`)
  if (alreadyThere !== null) {
    await watcher(`/_/tx.${txid}`)
  }
})

lib.disconnect = () => {
  currentConnection.end()
}

lib.searchContractsByAbi = async (path, abi) => {
  let ret = []
  let replacedPath = path.replace(/\//g, '\\/')
  let matcher = '^' + replacedPath + '[a-zA-Z]+\\.meta$'
  let iter = await lib.iterate({ gt: path, match: matcher }, 10)
  let chunk = await iter()
  while (chunk !== null) {
    for (let i=0; i < chunk.length; i++) {
      const {key, value} = chunk[i]
      const entrypointsKey = key.replace('.meta', '.entrypoints')
      const contractKey = key.replace('.meta', '')
      let entrypoints = await lib.get(entrypointsKey)

      if (isAbiCompatible(abi, entrypoints)) {
        ret.push([contractKey, value])
      }
    }

    chunk = await iter()
  }

  return ret
}

/**
 * Deploy bundle contract
 * @function
 * @name deployBundle
 * @memberof hazama-lib/Bundle
 * 
 * @param {object} params parameters for deploying bundle contract
 * @param {string} params.network the chain name or rpc url
 * @param {Signer} [params.signer] Signer to be used to sign messages and transactions.<br/>If private key is not set, Signer is required.
 * @param {string} [params.privateKey] wallet's private key.<br/>If Signer is not set, private key is required.
 * @param {BundleContractDeployMetadata} params.metadata Options for deploying an bundle contract
 * @param {string} [params.relayerUrl] relayer url (gasless transaction mode)
 * @returns {string} the address of the deployed contract
 * 
 * @example <caption>[Deploy bundle with privateKey]</caption>
 * import hazlib from hazama-lib
 * ...
 * const network = 'polygon'
 * const privateKey = 'dummy'
 * const metadata = {
 *   name: "My bundle"
 * }
 * const contractAddress = hazlib.deployBundle({ network, privateKey, metadata })
 * ...
 * 
 * @example <caption>[Deploy bundle with signer and relayer]</caption>
 * import hazlib from hazama-lib
 * ...
 * const network = 'polygon'
 * const signer = <signer object>
 * const relayerUrl = 'https://api.defender.openzeppelin.com/autotasks/0f7cf308-.../runs/webhook/fd447953-...' // Openzeppelin webhook URI
 * const metadata = {
 *   name: "My bundle"
 * }
 * const contractAddress = hazlib.deployBundle({ network, signer, metadata, relayerUrl })
 * ...
 */
lib.deployBundle = async ({network, signer, privateKey, metadata, relayerUrl}) => {
  try {
    let options = undefined

    if (!network) throw new Error(messages.NETWORK_UNDEFINED)

    if (!signer && !privateKey) throw new Error(messages.SIGNER_PRIVATEKEY_UNDEFINED)
  
    if (!metadata) throw new Error(messages.METADATA_UNDEFINED)
  
    if (!metadata.name) throw new Error(messages.CONTRACT_NAME_UNDEFINED)

    if (relayerUrl) {
      options = {
        gasless: {
          openzeppelin: {relayerUrl}
        }
      }         
    }
  
    let sdk = new ThirdwebSDK(network, options)
    if (signer) {
      sdk.updateSignerOrProvider(signer)
    }
  
    if (privateKey) {
      sdk = new ThirdwebSDK(
        new ethers.Wallet(
          privateKey,
          ethers.getDefaultProvider(getRpcUrlsByNetWork(network))
        )
      )
    }
  
    return await sdk.deployer.deployMultiwrap(metadata)
  } catch (e) {
    lib.emit('error', e)
  }
}

/**
 * Wrap tokens (ERC20/ERC721/ERC1155) into a single wrapped token
 * @function
 * @name wrapTokens
 * @memberof hazama-lib/Bundle
 * 
 * 
 * @example <caption>[Wrap tokens with privateKey]</caption>
 * import hazlib from hazama-lib
 * ...
 * const network = 'polygon'
 * const privateKey = 'dummy'
 * const contractAddress = '0x...'
 * const contents = {
 *   erc20Tokens: [
 *     {
 *       contractAddress: "0x...",
 *       quantity: "0.8",
 *     },
 *   ],
 *   erc721Tokens: [
 *     {
 *       contractAddress: "0x...",
 *       tokenId: "0",
 *     },
 *   ],
 *   erc1155Tokens: [
 *     {
 *       contractAddress: "0x...",
 *       tokenId: "1",
 *       quantity: "2",
 *     },
 *   ],
 * }
 * const wrappedTokenMetadata = {
 *   name: 'wrapped token name'
 * }
 * 
 * const toNumber = hazlib.wrapTokens({ network, privateKey, contractAddress, contents, wrappedTokenMetadata })
 * ...
 * 
 * @example <caption>[Wrap tokens with signer and relayer]</caption>
 * import hazlib from hazama-lib
 * ...
 * const network = 'polygon'
 * const signer = <signer object>
 * const relayerUrl = 'https://api.defender.openzeppelin.com/autotasks/0f7cf308-.../runs/webhook/fd447953-...' // Openzeppelin webhook URI
 * const contractAddress = '0x...'
 * const contents = {
 *   erc20Tokens: [
 *     {
 *       contractAddress: "0x...",
 *       quantity: "0.8",
 *     },
 *   ],
 *   erc721Tokens: [
 *     {
 *       contractAddress: "0x...",
 *       tokenId: "0",
 *     },
 *   ],
 *   erc1155Tokens: [
 *     {
 *       contractAddress: "0x...",
 *       tokenId: "1",
 *       quantity: "2",
 *     },
 *   ],
 * }
 * const wrappedTokenMetadata = {
 *   name: 'wrapped token name'
 * }
 * 
 * const toNumber = hazlib.wrapTokens({ network, signer, contractAddress, contents, wrappedTokenMetadata, relayerUrl })
 * ...
 * 
 * @param {object} params parameters for wrapping tokens
 * @param {string} params.network the chain name or rpc url
 * @param {Signer} [params.signer] Signer to be used to sign messages and transactions.<br/>If private key is not set, Signer is required.
 * @param {string} [params.privateKey] wallet's private key.<br/>If Signer is not set, private key is required.
 * @param {TokensToWrap} params.contents the contents to wrap
 * @param {NFTMetadataOrUri} params.wrappedTokenMetadata metadata to represent the wrapped token bundle
 * @param {string} [params.recipientAddress] The address to send the wrapped token bundle to
 * @param {string} [params.relayerUrl] relayer url (gasless transaction mode)
 * @returns {number} the id of the wrapped token bundle
 */
lib.wrapTokens = async ({network, signer, privateKey, contractAddress, contents, wrappedTokenMetadata = {}, recipientAddress, relayerUrl}) => {
  try {
    let options = undefined

    if (!network) throw new Error(messages.NETWORK_UNDEFINED)

    if (!signer && !privateKey) throw new Error(messages.SIGNER_PRIVATEKEY_UNDEFINED)
  
    if (!contractAddress) throw new Error(messages.CONTRACT_ADDRESS_UNDEFINED)
  
    if (!contents) throw new Error(messages.CONTENTS_TO_WRAP_UNDEFINED)

    if (relayerUrl) {
      options = {
        gasless: {
          openzeppelin: {relayerUrl}
        }
      }         
    }
  
    let sdk = new ThirdwebSDK(network, options)
    if (signer) {
      sdk.updateSignerOrProvider(signer)
    }
  
    if (privateKey) {
      sdk = new ThirdwebSDK(
        new ethers.Wallet(
          privateKey,
          ethers.getDefaultProvider(getRpcUrlsByNetWork(network))
        )
      )
    }
  
    const contract = sdk.getMultiwrap(contractAddress)
    const tx = await contract.wrap(contents, wrappedTokenMetadata, recipientAddress)
  
    return tx.id.toNumber()
  } catch (e) {
    lib.emit('error', e)
  }
}

/** 
 * 
 * Get the contents of a wrapped token bundle
 * @function
 * @name getWrappedContents
 * @memberof hazama-lib/Bundle
 * 
 * @example
 * import hazlib from hazama-lib
 * ...
 * const network = 'polygon'
 * const contractAddress = '0x...'
 * const tokenId = 0
 * 
 * const wrappedTokens = hazlib.getWrappedContents({ network, contractAddress, tokenId })
 * ...
 * 
 * @param {object} params parameters for getting contents of a wrapped token bundle
 * @param {string} params.network the chain name or rpc url
 * @param {string} params.contractAddress the address of the deployed contract
 * @param {BigNumberish} params.tokenId the id of the wrapped token bundle
 * @returns {WrappedTokensOutput} Output for the contents of a bundle wrapped token
 */
lib.getWrappedContents = async ({network, contractAddress, tokenId}) => {
  try {
    if (!network) throw new Error(messages.NETWORK_UNDEFINED)

    if (!contractAddress) throw new Error(messages.CONTRACT_ADDRESS_UNDEFINED)
    
    if (!tokenId && tokenId !== 0) throw new Error(messages.TOKEN_ID_UNDEFINED)

    let sdk = new ThirdwebSDK(network)

    const contract = sdk.getMultiwrap(contractAddress)
    const wrappedContents = await contract.getWrappedContents(tokenId);
    const promises = Object.keys(wrappedContents).map(async key => {
      let contract, contractMetadata, token
      const tokenContents = wrappedContents[key]
      if (isArrayFull(tokenContents)) {
        const childPromises = tokenContents.map(async tokenContent => {
          const {contractAddress: tokenAddress, tokenId} = tokenContent
          const contractType = await sdk.resolveContractType(tokenAddress)
          switch (key) {
            case 'erc20Tokens':
              contract = sdk.getToken(tokenAddress)
              contractMetadata = await contract.metadata.get()
              tokenContent.contractName = contractMetadata?.name || ''
              token = await contract.get();
              tokenContent.tokenName = token?.name || ''
              break
            case 'erc721Tokens':
              contract = contractType === REMOTE_CONTRACT_TO_CONTRACT_TYPE.TokenERC721 ?
                sdk.getNFTCollection(tokenAddress) :
                sdk.getNFTDrop(tokenAddress)
              contractMetadata = await contract.metadata.get()
              tokenContent.contractName = await contractMetadata?.name || ''
              token = await contract.get(tokenId);
              tokenContent.tokenName = token?.metadata?.name || ''
              break
            case 'erc1155Tokens':
              contract = contractType === REMOTE_CONTRACT_TO_CONTRACT_TYPE.TokenERC1155 ?
                sdk.getEdition(tokenAddress) :
                sdk.getEditionDrop(tokenAddress)
              contractMetadata = await contract.metadata.get()
              tokenContent.contractName = await contractMetadata?.name  || ''
              token = await contract.get(tokenId)
              tokenContent.tokenName = token?.metadata?.name || ''
              break
          }
        })
        return await Promise.all(childPromises)
      }
    })

    const result = await Promise.all(promises)
    return result ? wrappedContents : {
      erc20Tokens: [],
      erc721Tokens: [],
      erc1155Tokens: []
    }
  } catch (e) {
    lib.emit('error', e)
  }
}

/**
 * Transfer a wrapped token bundle
 * @function
 * @name transfer
 * @memberof hazama-lib/Bundle
 * 
 * @example <caption>Transfer a wrapped token bundle with privateKey</caption>
 * import hazlib from hazama-lib
 * ...
 * const network = 'polygon'
 * const privateKey = 'dummy'
 * const contractAddress = '0x...'
 * const tokenId = 0
 * 
 * const toNumber = hazlib.transfer({ network, privateKey, contractAddress, tokenId })
 * ...
 * 
 * @example <caption>Transfer a wrapped token bundle with signer and relayer</caption>
 * import hazlib from hazama-lib
 * ...
 * const network = 'polygon'
 * const signer = <signer object>
 * const relayerUrl = 'https://api.defender.openzeppelin.com/autotasks/0f7cf308-.../runs/webhook/fd447953-...' // Openzeppelin webhook URI
 * const contractAddress = '0x...'
 * const tokenId = 0
 * 
 * const toNumber = hazlib.transfer({ network, signer, contractAddress, tokenId, relayerUrl })
 * ...
 * 
 * @param {object} params parameters for transferring a wrapped token bundle
 * @param {string} params.network the chain name or rpc url
 * @param {Signer} [params.signer] Signer to be used to sign messages and transactions.<br/>If private key is not set, Signer is required.
 * @param {string} [params.privateKey] wallet's private key.<br/>If Signer is not set, private key is required.
 * @param {string} params.contractAddress the address of the deployed contract
 * @param {BigNumberish} params.tokenId the token ID to transfer
 * @param {string} [params.recipientAddress] address to transfer the tokens to
 * @param {string} [params.relayerUrl] relayer url (gasless transaction mode)
 * @returns {TransactionResult} TransactionResult
 */
lib.transfer = async ({ network, signer, privateKey, contractAddress, tokenId, recipientAddress, relayerUrl }) => {
  try {
    let options = undefined

    if (!network) throw new Error(messages.NETWORK_UNDEFINED)

    if (!signer && !privateKey) throw new Error(messages.SIGNER_PRIVATEKEY_UNDEFINED)
  
    if (!contractAddress) throw new Error(messages.CONTRACT_ADDRESS_UNDEFINED)
  
    if (!tokenId && tokenId !== 0) throw new Error(messages.TOKEN_ID_UNDEFINED)
  
    if (!recipientAddress) throw new Error(messages.RECIPIENT_ADDRESS_UNDEFINED)

    if (relayerUrl) {
      options = {
        gasless: {
          openzeppelin: {relayerUrl}
        }
      }         
    }
  
    let sdk = new ThirdwebSDK(network, options)
    if (signer) {
      sdk.updateSignerOrProvider(signer)
    }
  
    if (privateKey) {
      sdk = new ThirdwebSDK(
        new ethers.Wallet(
          privateKey,
          ethers.getDefaultProvider(getRpcUrlsByNetWork(network))
        )
      )
    }
  
    const contract = sdk.getMultiwrap(contractAddress)
  
    return await contract.transfer(recipientAddress, tokenId)
  } catch (e) {
    lib.emit('error', e)
  }
}

/**
 * Unwrap a wrapped token bundle, and retrieve its contents
 * @function
 * @name unwrap
 * @memberof hazama-lib/Bundle
 * 
 * @example <caption>[Unwrap token with privateKey]</caption>
 * import hazlib from hazama-lib
 * ...
 * const network = 'polygon'
 * const privateKey = 'dummy'
 * const contractAddress = '0x...'
 * const tokenId = 0
 * 
 * const toNumber = hazlib.unwrap({ network, privateKey, contractAddress, tokenId })
 * ...
 * 
 * @example <caption>[Unwrap token with signer and relayer]</caption>
 * import hazlib from hazama-lib
 * ...
 * const network = 'polygon'
 * const signer = <signer object>
 * const relayerUrl = 'https://api.defender.openzeppelin.com/autotasks/0f7cf308-.../runs/webhook/fd447953-...' // Openzeppelin webhook URI
 * const contractAddress = '0x...'
 * const tokenId = 0
 * 
 * const toNumber = hazlib.unwrap({ network, signer, contractAddress, tokenId, relayerUrl })
 * ...
 * 
 * @param {object} params parameters for unwrapping a wrapped token bundle
 * @param {string} params.network the chain name or rpc url
 * @param {Signer} [params.signer] Signer to be used to sign messages and transactions.<br/>If private key is not set, Signer is required.
 * @param {string} [params.privateKey] wallet's private key.<br/>If Signer is not set, private key is required.
 * @param {string} params.contractAddress the address of the deployed contract
 * @param {BigNumberish} params.tokenId the token ID to unwrap
 * @param {string} [params.recipientAddress] address to transfer the tokens to
 * @param {string} [params.relayerUrl] relayer url (gasless transaction mode)
 * @returns {TransactionResult} TransactionResult
 */
lib.unwrap = async ({network, signer, privateKey, contractAddress, tokenId, recipientAddress, relayerUrl}) => {
  try {
    let options = undefined

    if (!network) throw new Error(messages.NETWORK_UNDEFINED)

    if (!signer && !privateKey) throw new Error(messages.SIGNER_PRIVATEKEY_UNDEFINED)
  
    if (!contractAddress) throw new Error(messages.CONTRACT_ADDRESS_UNDEFINED)
  
    if (!tokenId && tokenId !== 0) throw new Error(messages.TOKEN_ID_UNDEFINED)

    if (relayerUrl) {
      options = {
        gasless: {
          openzeppelin: {relayerUrl}
        }
      }         
    }

    let sdk = new ThirdwebSDK(network, options)
    if (signer) {
      sdk.updateSignerOrProvider(signer)
    }
  
    if (privateKey) {
      sdk = new ThirdwebSDK(
        new ethers.Wallet(
          privateKey,
          ethers.getDefaultProvider(getRpcUrlsByNetWork(network))
        )
      )
    }
  
    const contract = sdk.getMultiwrap(contractAddress)
  
    return await contract.unwrap(tokenId, recipientAddress) 
  } catch (e) {
    lib.emit('error', e)
  }
}

/**
 * Set approval for token (ERC20/ERC721/ERC1155)
 * @function
 * @name setApprovalForToken
 * @memberof hazama-lib/Bundle
 * 
 * @example <caption>Set approval for token with privateKey</caption>
 * import hazlib from hazama-lib
 * ...
 * const network = 'polygon'
 * const privateKey = 'dummy'
 * const contractAddress = '0x...'
 * const tokenType = 'erc20'
 * const tokenWrappable = {
 *  contractAddress: "0x...",
 *  quantity: "0.8",
 * }
 * 
 * const toNumber = hazlib.setApprovalForToken({ network, privateKey, contractAddress, tokenType, tokenWrappable })
 * ...
 * 
 * @example <caption>Set approval for token with signer and relayer</caption>
 * import hazlib from hazama-lib
 * ...
 * const network = 'polygon'
 * const signer = <signer object>
 * const relayerUrl = 'https://api.defender.openzeppelin.com/autotasks/0f7cf308-.../runs/webhook/fd447953-...' // Openzeppelin webhook URI
 * const contractAddress = '0x...'
 * const tokenType = 'erc20'
 * const tokenWrappable = {
 *  contractAddress: "0x...",
 *  quantity: "0.8",
 * }
 * 
 * const toNumber = hazlib.setApprovalForToken({ network, signer, contractAddress, tokenType, tokenWrappable, relayerUrl })
 * ...
 * 
 * @param {object} params parameters for setting approval for token
 * @param {string} params.network the chain name or rpc url
 * @param {Signer} [params.signer] Signer to be used to sign messages and transactions.<br/>If private key is not set, Signer is required.
 * @param {string} [params.privateKey] wallet's private key.<br/>If Signer is not set, private key is required.
 * @param {string} params.contractAddress the operator/spender's address
 * @param {('erc20'|'erc721'|'erc1155')} params.tokenType token type
 * @param {(ERC20Wrappable|ERC721Wrappable|ERC1155Wrappable)} params.tokenWrappable Represents a token/NFT that can be wrapped
 * @param {string} [params.relayerUrl] relayer url (gasless transaction mode)
 * @returns {boolean} result
 */
lib.setApprovalForToken = async ({network, signer, privateKey, contractAddress, tokenType, tokenWrappable, relayerUrl}) => {
  try {
    let result = false
    let options = undefined
  
    if (!network) throw new Error(messages.NETWORK_UNDEFINED)
  
    if (!signer && !privateKey) throw new Error(messages.SIGNER_PRIVATEKEY_UNDEFINED)
  
    if (!contractAddress) throw new Error(messages.CONTRACT_ADDRESS_UNDEFINED)
  
    if (!tokenType) throw new Error(messages.TOKEN_TYPE_UNDEFINED)
  
    if (!tokenWrappable) throw new Error(messages.TOKEN_WRAPPABLE_UNDEFINED)
  
    if (typeof tokenWrappable.contractAddress === 'undefined') throw new Error(messages.CONTRACT_ADDRESS_UNDEFINED)
  
    if (tokenType === TokenType.ERC20 && typeof tokenWrappable.quantity === 'undefined') throw new Error(messages.TOKEN_QUANTITY_UNDEFINED)
  
    if (tokenType === TokenType.ERC721 && typeof tokenWrappable.tokenId === 'undefined') throw new Error(messages.TOKEN_ID_UNDEFINED)

    if (relayerUrl) {
      options = {
        gasless: {
          openzeppelin: {relayerUrl}
        }
      }         
    }
  
    let sdk = new ThirdwebSDK(network, options)
    if (signer) {
      sdk.updateSignerOrProvider(signer)
    }
  
    if (privateKey) {
      sdk = new ThirdwebSDK(
        new ethers.Wallet(
          privateKey,
          ethers.getDefaultProvider(getRpcUrlsByNetWork(network))
        )
      )
    }
  
    const {contractAddress: tokenAddress, tokenId, quantity, approved} = tokenWrappable
    const contract = await sdk.getContract(tokenAddress)
    switch (tokenType) {
      case TokenType.ERC20:
        const allowance = await contract.token.allowance(contractAddress)
        if (quantity > (allowance?.displayValue || 0)) {
          await contract.token.setAllowance(contractAddress, quantity)
        }
        result = true
        break
      case TokenType.ERC721:
        const erc721Owner = await contract.nft.ownerOf(tokenId)
        const erc721ApprovedStatus = typeof approved === 'boolean' ? approved : true
        if (erc721ApprovedStatus) {
          const isERC721Approved = await contract.nft.isApproved(erc721Owner, contractAddress)
          if (!isERC721Approved) {
            await contract.nft.setApprovalForAll(contractAddress, true)
          }
        } else {
          await contract.nft.setApprovalForAll(contractAddress, false)
        }
        result = true
        break
      case TokenType.ERC1155:
        const erc1155ApprovedStatus = typeof approved === 'boolean' ? approved : true
        if (erc1155ApprovedStatus) {
          const isERC1155Approved = await contract.edition.isApproved(signer.getAddress(), contractAddress)
          if (!isERC1155Approved) {
            await contract.edition.setApprovalForAll(contractAddress, true)
          }
        } else {
          await contract.edition.setApprovalForAll(contractAddress, false)
        }
        result = true
        break
    }
  
    return result
  } catch (e) {
    lib.emit('error', e)
  }
}

/**
 * Get Wrapped token bundles loop
 * @private
 * 
 * @param {object} params parameters for getting contents of a wrapped token bundle
 * @param {Multiwrap} params.contract the deployed contract
 * @param {QueryAllParams} params.queryParams Pagination Parameters
 * @return {Promise<NFTMetadataOwner[]>} promise
 */
function getWrappedBundlesLoop({contract, queryParams = {start: 0, count: 100}}) {
  return contract.getAll(queryParams)
}

/**
 * Get all Wrapped token bundles
 * @function
 * @name getWrappedBundles
 * @memberof hazama-lib/Bundle
 * 
 * @example
 * import hazlib from hazama-lib
 * ...
 * const network = 'polygon'
 * const contractAddress = '0x...'
 * 
 * const wrappedTokens = hazlib.getWrappedBundles({ network, contractAddress })
 * ...
 * 
 * @param {object} params parameters for getting contents of a wrapped token bundle
 * @param {string} params.network the chain name or rpc url
 * @param {string} params.contractAddress the address of the deployed contract
 * @param {QueryAllParams} [params.queryParams] Pagination Parameters
 * @returns {NFTMetadataOwner[]} The NFT metadata for all tokens/NFTs queried.
 */
lib.getWrappedBundles = async ({network, contractAddress, queryParams = {start: 0, count: DEFAULT_QUERY_ALL_COUNT}}) => {
  try {
    if (!network) throw new Error(messages.NETWORK_UNDEFINED)

    if (!contractAddress) throw new Error(messages.CONTRACT_ADDRESS_UNDEFINED)
  
    let sdk = new ThirdwebSDK(network)
  
    const contract = sdk.getMultiwrap(contractAddress)
    
    let wrappedBundlesAll = []
  
    let newQueryParams = {...queryParams}
  
    while (true) {
      const wrappedBundles = await getWrappedBundlesLoop({contract, queryParams: newQueryParams})
      wrappedBundlesAll = wrappedBundlesAll.concat(wrappedBundles.map(el => Object.assign({}, el)))
  
      if (wrappedBundles.length < DEFAULT_QUERY_ALL_COUNT) break
  
      newQueryParams = {
        ...newQueryParams,
        start: newQueryParams.start + DEFAULT_QUERY_ALL_COUNT,
      }
    } 
  
    return wrappedBundlesAll
  } catch (e) {
    lib.emit('error', e)
  }
}

/**
 * Compile and broadcast
 * 
 * @private
 * @param {object} params parameters for compiling and broadcasting
 * @param {string} params.host host
 * @param {string} params.asm asm
 * @param {Signer} [params.signer] Signer to be used to sign messages and transactions
 * @param {string} [params.wif] wallet import format
 * @returns {Promise<string>} promise
 */
async function compileAndBroadcast({host, asm, signer, wif}) {
  return new Promise(async (resolve, reject) => {
    try {
      if( !/^#asm/.test(asm) ) {
        asm = "#asm\n" + asm
      }

      if (!signer && !wif) throw new Error(messages.SIGNER_WIF_UNDEFINED)
      
      const code = lib.compile(asm)
      let envelope = typeof wif !== 'undefined' ? lib.envelope(code, wif) : await lib.envelopeWithWallet(code, signer)
      
      lib.connect(host, async () => {
        const txid = await lib.tx(envelope)
        await lib.waitMinedTx(txid)
        resolve(txid)
      })
    }
    catch(e){
      reject(e)
    }
  })
}

/**
 * Deploy contract on EVM network
 * 
 * @private
 * @param {object} params parameters for deploying contract
 * @param {string} params.network the chain name or rpc url
 * @param {Signer} [params.signer] Signer to be used to sign messages and transactions.<br/>If private key is not set, Signer is required.
 * @param {string} [params.privateKey] wallet's private key.<br/>If Signer is not set, private key is required.
 * @param {('nft-collection'|'nft-drop'|'edition-drop'|'token')} params.contractType the contract type
 * @param {(NFTContractDeployMetadata|TokenContractDeployMetadata)} params.contractMetadata contract metadata
 * @param {string} [params.relayerUrl] relayer url (gasless transaction mode)
 * @return {Promise<string>} promise
 */
async function deployContractOnEVMNetwork({network, signer, privateKey, contractType, contractMetadata, relayerUrl}) {
  return new Promise(async (resolve, reject) => {
    try {
      let result = null
      let options = undefined

      if (!network) throw new Error(messages.NETWORK_UNDEFINED)
    
      if (!signer && !privateKey) throw new Error(messages.SIGNER_PRIVATEKEY_UNDEFINED)
    
      if (!contractType) throw new Error(messages.CONTRACT_TYPE_UNDEFINED)
    
      if (
        ![
          'nft-collection',
          'nft-drop',
          'edition-drop',
          'token'
        ].includes(contractType)
      )
        throw new Error(messages.CONTRACT_TYPE_IS_INVALID)

      if (!contractMetadata) throw new Error(messages.CONTRACT_METADATA_UNDEFINED)
    
      if (!contractMetadata.name) throw new Error(messages.CONTRACT_NAME_UNDEFINED)
    
      if (!contractMetadata.primary_sale_recipient) throw new Error(messages.PRIMARY_SALE_RECIPIENT_UNDEFINED)

      if (relayerUrl) {
        options = {
          gasless: {
            openzeppelin: {relayerUrl}
          }
        }         
      }
    
      let sdk = new ThirdwebSDK(network, options)

      if (signer) {
        sdk.updateSignerOrProvider(signer)
      }
    
      if (privateKey) {
        sdk = new ThirdwebSDK(
          new ethers.Wallet(
            privateKey,
            ethers.getDefaultProvider(getRpcUrlsByNetWork(network))
          )
        )
      }
    
      const deployer = sdk.deployer
      switch(contractType) {
        case REMOTE_CONTRACT_TO_CONTRACT_TYPE.TokenERC721:
          result = await deployer.deployNFTCollection(contractMetadata)
          break
        case REMOTE_CONTRACT_TO_CONTRACT_TYPE.DropERC721:
          result = await deployer.deployNFTDrop(contractMetadata)
          break
        case REMOTE_CONTRACT_TO_CONTRACT_TYPE.TokenERC20:
          result = await deployer.deployToken(contractMetadata)
          break
        case REMOTE_CONTRACT_TO_CONTRACT_TYPE.DropERC1155:
          result = await deployer.deployEditionDrop(contractMetadata)
          break
        default:
          throw new Error(messages.CONTRACT_TYPE_IS_NOT_SUPPORTED)
      }
      resolve(result)
    } catch (e) {
      reject(e)
    }
  })
}

/**
 * Deploy contract on Hazama network
 * 
 * @private
 * @param {object} params parameters for deploying contract
 * @param {Signer} [params.signer] Signer to be used to sign messages and transactions.<br/>If wif is not set, Signer is required.
 * @param {string} [params.wif] wallet import format.<br/>If Signer is not set, wif is required.
 * @param {string} params.host host
 * @param {('nft_extensible'|'nft_nontransferable'|'fungible_token')} params.contractTemplate the contract template
 * @param {HazamaTokenContractDeployMetadata} params.contractMetadata contract metadata
 * @return {Promise<string>} promise
 */
async function deployContractOnHamazaNetwork({signer, wif, host, contractTemplate, contractMetadata}) {
  return new Promise(async (resolve, reject) => {
    try {
      if (!signer && !wif) throw new Error(messages.SIGNER_WIF_UNDEFINED)

      if (!host) throw new Error(messages.HOST_UNDEFINED)
    
      if (!contractTemplate) throw new Error(messages.CONTRACT_TEMPLATE_UNDEFINED)
    
      if (
        ![
          'nft_extensible',
          'nft_nontransferable',
          'fungible_token'
        ].includes(contractTemplate)
      )
        throw new Error(messages.CONTRACT_TEMPLATE_IS_INVALID)
    
      if (!contractMetadata) throw new Error(messages.CONTRACT_METADATA_UNDEFINED)
    
      if (!contractMetadata.name) throw new Error(messages.CONTRACT_NAME_UNDEFINED)
    
      if (!contractMetadata.primarySaleRecipient) throw new Error(messages.PRIMARY_SALE_RECIPIENT_UNDEFINED)
    
      if (!contractMetadata.path) throw new Error(messages.CONTRACT_PATH_UNDEFINED)
    
      if (!contractMetadata.author) throw new Error(messages.CONTRACT_AUTHOR_UNDEFINED)
    
      if (!contractMetadata.tokenVersion) throw new Error(messages.TOKEN_VERSION_UNDEFINED)
    
      if (!contractMetadata.decimals) throw new Error(messages.TOKEN_DECIMALS_UNDEFINED)
    
      let asm = await lib.template(contractTemplate, contractMetadata)
      const result = await compileAndBroadcast({host, asm, signer, wif})
      resolve(result)
    } catch (e) {
      reject(e)
    }
  })
}

/**
 * Deploy contract for token (ERC20/ERC721/ERC1155)
 * @function
 * @name deployContract
 * @memberof hazama-lib/ERC20/ERC721/ERC1155
 * 
 * @example <caption>[Deploy contract with privateKey on EVM network]</caption>
 * import hazlib from 'hazama-lib'
 * ...
 * const network = 'polygon'
 * const privateKey = 'dummy'
 * const contractAddress = '0x...'
 * const contractType = 'nft-collection'
 * const contractMetadata = {
 *  name: 'contract name',
 *  primary_sale_recipient: '0x...',
 *  ...
 * }
 * 
 * const contract = hazlib.deployContract({ network, privateKey, contractType, contractMetadata })
 * ...
 * 
 * @example <caption>[Deploy contract with signer and relayer on EVM network]</caption>
 * import hazlib from 'hazama-lib'
 * ...
 * const network = 'polygon'
 * const signer = <signer object>
 * const relayerUrl = 'https://api.defender.openzeppelin.com/autotasks/0f7cf308-.../runs/webhook/fd447953-...' // Openzeppelin webhook URI
 * const contractAddress = '0x...'
 * const contractType = 'nft-collection'
 * const contractMetadata = {
 *  name: 'contract name',
 *  primary_sale_recipient: '0x...',
 *  ...
 * }
 * 
 * const contract = hazlib.deployContract({ network, signer, contractType, contractMetadata, relayerUrl })
 * ...
 * 
 * @example <caption>[Deploy contract on Hazama network]</caption>
 * import hazlib from 'hazama-lib'
 * ...
 * const network = 'hazama'
 * const wif = 'dummny'
 * const host = 'wss://n.hazama.io'
 * const contractTemplate = 'nft_extensible'
 * const contractMetadata = {
 *  path: '/hazama/...',
 *  name: 'contract name',
 *  primarySaleRecipient: '0x...',
 *  author: 'author name',
 *  tokenVersion: '0.0.1',
 *  decimals: 18,
 *  ...
 * }
 * 
 * const contract = hazlib.deployContract({ network, wif, host, contractTemplate, contractMetadata })
 * ...
 * 
 * @param {object} params parameters for deploying contract
 * @param {string} params.network the chain name or rpc url
 * @param {Signer} [params.signer] Signer to be used to sign messages and transactions
 * @param {string} [params.privateKey] wallet's private key
 * @param {string} [params.wif] wallet import format
 * @param {string} [params.host] host
 * @param {('nft-collection'|'nft-drop'|'edition-drop'|'token')} [params.contractType] the contract type
 * @param {('nft_extensible'|'nft_nontransferable'|'fungible_token')} [params.contractTemplate] the contract template (use by Hamaza network)
 * @param {(NFTContractDeployMetadata|TokenContractDeployMetadata|HazamaTokenContractDeployMetadata)} params.contractMetadata contract metadata
 * @param {string} [params.relayerUrl] relayer url (gasless transaction mode)
 * @return {string} contract id or transaction id (Hazama)
 */
lib.deployContract = async ({network, signer, privateKey, wif, host, contractType, contractTemplate, contractMetadata, relayerUrl}) => {
  try {
    if (!network) throw new Error(messages.NETWORK_UNDEFINED)

    return network !== 'hazama' ?
      await deployContractOnEVMNetwork({network, signer, privateKey, contractType, contractMetadata, relayerUrl}) :
      await deployContractOnHamazaNetwork({signer, wif, host, contractTemplate, contractMetadata})
  } catch (e) {
    lib.emit('error', e)
  }
}

/**
 * Mint token on EVM network
 * 
 * @private
 * @param {object} params parameters for minting token
 * @param {string} params.network the chain name or rpc url
 * @param {Signer} [params.signer] Signer to be used to sign messages and transactions.<br/>If private key is not set, Signer is required.
 * @param {string} [params.privateKey] wallet's private key.<br/>If Signer is not set, private key is required.
 * @param {string} params.contractAddress the token contract address
 * @param {('nft-collection'|'nft-drop'|'edition-drop'|'token')} params.contractType the contract type
 * @param {string} params.recipientAddress address to transfer the tokens to
 * @param {Amount} params.quantity number of tokens to transfer
 * @param {(NFTMetadataOrUri[]|NFTMetadataOrUri)} [params.metadata] token metadata
 * @param {string} [params.relayerUrl] relayer url (gasless transaction mode)
 * @return {Promise<TransactionResult|TransactionResultWithId[]>} promise
 */
async function mintTokenOnEVMNetwork({network, signer, privateKey, contractAddress, contractType, recipientAddress, quantity, metadata, relayerUrl}) {
  return new Promise(async (resolve, reject) => {
    try {
      let contract = null
      let result = null
      let options = undefined

      if (!network) throw new Error(messages.NETWORK_UNDEFINED)

      if (!signer && !privateKey) throw new Error(messages.SIGNER_PRIVATEKEY_UNDEFINED)

      if (!contractAddress) throw new Error(messages.CONTRACT_ADDRESS_UNDEFINED)

      if (!contractType) throw new Error(messages.CONTRACT_TYPE_UNDEFINED)

      if (
        [
          REMOTE_CONTRACT_TO_CONTRACT_TYPE.TokenERC20,
          REMOTE_CONTRACT_TO_CONTRACT_TYPE.TokenERC721
        ].includes(contractType)
        && !recipientAddress
      )
        throw new Error(messages.RECIPIENT_ADDRESS_UNDEFINED)

      if (contractType === REMOTE_CONTRACT_TO_CONTRACT_TYPE.TokenERC20 && !quantity)
        throw new Error(messages.TOKEN_QUANTITY_UNDEFINED) 

      if (
        [
          REMOTE_CONTRACT_TO_CONTRACT_TYPE.DropERC1155,
          REMOTE_CONTRACT_TO_CONTRACT_TYPE.DropERC721,
          REMOTE_CONTRACT_TO_CONTRACT_TYPE.TokenERC721
        ].includes(contractType) 
        && !metadata
      )
        throw new Error(messages.METADATA_UNDEFINED)

      if (relayerUrl) {
        options = {
          gasless: {
            openzeppelin: {relayerUrl}
          }
        }         
      }

      let sdk = new ThirdwebSDK(network, options)
    
      if (signer) {
        sdk.updateSignerOrProvider(signer)
      }
    
      if (privateKey) {
        sdk = new ThirdwebSDK(
          new ethers.Wallet(
            privateKey,
            ethers.getDefaultProvider(getRpcUrlsByNetWork(network))
          )
        )
      }

      switch (contractType) {
        case REMOTE_CONTRACT_TO_CONTRACT_TYPE.TokenERC20:
          contract = sdk.getToken(contractAddress)
          result = await contract.mintTo(recipientAddress, quantity)
          break
        case REMOTE_CONTRACT_TO_CONTRACT_TYPE.DropERC1155:
          contract = sdk.getEditionDrop(contractAddress)
          result = await contract.createBatch(isArray(metadata) ? metadata : [metadata])
          break
        case REMOTE_CONTRACT_TO_CONTRACT_TYPE.DropERC721:
          contract = sdk.getNFTDrop(contractAddress)
          result = await contract.createBatch(isArray(metadata) ? metadata : [metadata])
          break
        case REMOTE_CONTRACT_TO_CONTRACT_TYPE.TokenERC721:
          contract = sdk.getNFTCollection(contractAddress)
          const newMetadata = isArray(metadata) ? metadata : [metadata]
          result = await contract.mintBatchTo(recipientAddress, newMetadata)
          break
        default:
          throw new Error (messages.TOKEN_TYPE_IS_NOT_SUPPORTED)
      }
      resolve(result)
    } catch (e) {
      reject(e)
    }
  })
}

/**
 * Mint token on Hazama network
 * 
 * @private
 * @param {object} params parameters for minting token
 * @param {Signer} [params.signer] Signer to be used to sign messages and transactions.<br/>If wif is not set, Signer is required.
 * @param {string} [params.wif] wallet import format.<br/>If Signer is not set, wif is required.
 * @param {string} params.host host
 * @param {('fungible_token_issuance'|'nft_extensible_mint'|'nft_multi_extensible_mint')} params.tokenTemplate the token template
 * @param {(NFTMetadataOrUri[]|NFTMetadataOrUri)} params.metadata token metadata
 * @return {Promise<string>} promise
 */
async function mintTokenOnHazamaNetwork({signer, wif, host, tokenTemplate, metadata}) {
  return new Promise(async (resolve, reject) => {
    try {
      if (!signer && !wif) throw new Error(messages.SIGNER_WIF_UNDEFINED)
      
      if (!host) throw new Error(messages.HOST_UNDEFINED)

      if (!tokenTemplate) throw new Error(messages.TOKEN_TEMPLATE_UNDEFINED)
  
      if (
        ![
          'fungible_token_issuance',
          'nft_extensible_mint',
          'nft_multi_extensible_mint'
        ].includes(tokenTemplate)
      )
        throw new Error(messages.TOKEN_TEMPLATE_IS_INVALID)
  
      if (!metadata) throw new Error(messages.METADATA_UNDEFINED)
  
      if (!metadata.path) throw new Error(messages.TOKEN_PATH_UNDEFINED)
  
      if (tokenTemplate === 'fungible_token_issuance') {
        if (!metadata.amount) throw new Error(messages.TOKEN_QUANTITY_UNDEFINED)
  
        if (!metadata.mintto) throw new Error(messages.RECIPIENT_ADDRESS_UNDEFINED)
      } else if (tokenTemplate === 'nft_extensible_mint') {
        if (!metadata.name) throw new Error(messages.TOKEN_NAME_UNDEFINED)
      } else if (tokenTemplate === 'nft_multi_extensible_mint') {
        if (!metadata.mints || (metadata.mints && !isArrayFull(metadata.mints))) throw new Error(messages.MINTS_UNDEFINED)
  
        if (metadata.mints.some(el => typeof el.name === 'undefined')) throw new Error(messages.TOKEN_NAME_UNDEFINED)
      }
      let asm = await lib.template(tokenTemplate, metadata)
      const result = await compileAndBroadcast({host, asm, signer, wif})
      resolve(result)
    } catch (e) {
      reject(e)
    }
  })
}

/**
 * Mint token (ERC20/ERC721/ERC1155)
 * @function
 * @name mint
 * @memberof hazama-lib/ERC20/ERC721/ERC1155
 * 
 * @example <caption>[Mint ERC20 with privateKey on EVM network]</caption>
 * import hazlib from 'hazama-lib'
 * ...
 * const network = 'polygon'
 * const privateKey = 'dummy'
 * const contractAddress = '0x...'
 * const contractType = 'token'
 * const recipientAddress = '0x...'
 * const quantity = '0.8'
 * 
 * const result = hazlib.mint({ network, privateKey, contractAddress, contractType, recipientAddress, quantity })
 * ...
 * 
 * @example <caption>[Mint ERC20 with signer and relayer on EVM network]</caption>
 * import hazlib from 'hazama-lib'
 * ...
 * const network = 'polygon'
 * const signer = <signer object>
 * const relayerUrl = 'https://api.defender.openzeppelin.com/autotasks/0f7cf308-.../runs/webhook/fd447953-...' // Openzeppelin webhook URI
 * const contractAddress = '0x...'
 * const contractType = 'token'
 * const recipientAddress = '0x...'
 * const quantity = '0.8'
 * 
 * const result = hazlib.mint({ network, signer, contractAddress, contractType, recipientAddress, quantity, relayerUrl })
 * ...
 * 
 * @example <caption>[Mint ERC721 with privateKey on EVM network]</caption>
 * import hazlib from 'hazama-lib'
 * ...
 * const network = 'polygon'
 * const privateKey = 'dummy'
 * const contractAddress = '0x...'
 * const contractType = 'nft-collection'
 * const recipientAddress = '0x...'
 * const metadata = [{
 *  name: 'token name',
 *  description: 'token description',
 *  ...
 * }]
 * 
 * const result = hazlib.mint({ network, privateKey, contractAddress, contractType, recipientAddress, metadata })
 * ...
 * 
 * @example <caption>[Mint ERC721 with signer and relayer on EVM network]</caption>
 * import hazlib from 'hazama-lib'
 * ...
 * const network = 'polygon'
 * const signer = <signer object>
 * const relayerUrl = 'https://api.defender.openzeppelin.com/autotasks/0f7cf308-.../runs/webhook/fd447953-...' // Openzeppelin webhook URI
 * const contractAddress = '0x...'
 * const contractType = 'nft-collection'
 * const recipientAddress = '0x...'
 * const metadata = [{
 *  name: 'token name',
 *  description: 'token description',
 *  ...
 * }]
 * 
 * const result = hazlib.mint({ network, signer, contractAddress, contractType, recipientAddress, metadata, relayerUrl })
 * ...
 * 
 * @example <caption>[Mint DropERC721 with privateKey on EVM network]</caption>
 * import hazlib from 'hazama-lib'
 * ...
 * const network = 'polygon'
 * const privateKey = 'dummy'
 * const contractAddress = '0x...'
 * const contractType = 'nft-drop'
 * const metadata = [{
 *  name: 'token name',
 *  description: 'token description',
 *  ...
 * }]
 * 
 * const result = hazlib.mint({ network, privateKey, contractAddress, contractType, metadata })
 * ...
 * 
 * @example <caption>[Mint DropERC721 with signer and relayer on EVM network]</caption>
 * import hazlib from 'hazama-lib'
 * ...
 * const network = 'polygon'
 * const signer = <signer object>
 * const relayerUrl = 'https://api.defender.openzeppelin.com/autotasks/0f7cf308-.../runs/webhook/fd447953-...' // Openzeppelin webhook URI
 * const contractAddress = '0x...'
 * const contractType = 'nft-drop'
 * const metadata = [{
 *  name: 'token name',
 *  description: 'token description',
 *  ...
 * }]
 * 
 * const result = hazlib.mint({ network, signer, contractAddress, contractType, metadata, relayerUrl })
 * ...
 * 
 * @example <caption>[Mint DropERC1155 with privateKey on EVM network]</caption>
 * import hazlib from 'hazama-lib'

 * ...
 * const network = 'polygon'
 * const privateKey = 'dummy'
 * const contractAddress = '0x...'
 * const contractType = 'edition-drop'
 * const metadata = [{
 *  name: 'token name',
 *  description: 'token description',
 *  ...
 * }]
 * 
 * const result = hazlib.mint({ network, privateKey, contractAddress, contractType, metadata })
 * ...
 * 
 * @example <caption>[Mint DropERC1155 with signer and relayer on EVM network]</caption>
 * import hazlib from 'hazama-lib'

 * ...
 * const network = 'polygon'
 * const signer = <signer object>
 * const relayerUrl = 'https://api.defender.openzeppelin.com/autotasks/0f7cf308-.../runs/webhook/fd447953-...' // Openzeppelin webhook URI
 * const contractAddress = '0x...'
 * const contractType = 'edition-drop'
 * const metadata = [{
 *  name: 'token name',
 *  description: 'token description',
 *  ...
 * }]
 * 
 * const result = hazlib.mint({ network, signer, contractAddress, contractType, metadata, relayerUrl })
 * ...
 * 
 * @example <caption>[Mint fungible token on Hazama network]</caption>
 * import hazlib from 'hazama-lib'

 * ...
 * const network = 'hazama'
 * const wif = 'dummny'
 * const host = 'wss://n.hazama.io'
 * const tokenTemplate = 'fungible_token_issuance'
 * const metadata = {
 *  path: '/hazama/...',
 *  amount: '2000000000000000000',
 *  mintto: '0x...'
 * }
 * 
 * const result = hazlib.mint({ network, wif, host, tokenTemplate, metadata })
 * ...
 * 
 * @example <caption>[Mint NFT on Hazama network]</caption>
 * import hazlib from 'hazama-lib'

 * ...
 * const network = 'hazama'
 * const wif = 'dummny'
 * const host = 'wss://n.hazama.io'
 * const tokenTemplate = 'nft_extensible_mint'
 * const metadata = {
 *  path: '/hazama/...',
 *  name: 'token name',
 *  description: 'token description',
 *  ...
 * }
 * 
 * const result = hazlib.mint({ network, wif, host, tokenTemplate, metadata })
 * ...
 * 
 * @example <caption>[Mint multiple NFTs on Hazama network]</caption>
 * import hazlib from 'hazama-lib'

 * ...
 * const network = 'hazama'
 * const wif = 'dummny'
 * const host = 'wss://n.hazama.io'
 * const tokenTemplate = 'nft_multi_extensible_mint'
 * const metadata = {
 *  path: '/hazama/...',
 *  mints: [
 *   {
 *    name: 'token name 1',
 *    description: 'token description',
 *    ...
 *   },
 *   {
 *    name: 'token name 2',
 *    description: 'token description',
 *    ...
 *   }
 *  ]
 * }
 * 
 * const result = hazlib.mint({ network, wif, host, tokenTemplate, metadata })
 * ...
 * 
 * @param {object} params parameters for minting token
 * @param {string} params.network the chain name or rpc url
 * @param {Signer} [params.signer] Signer to be used to sign messages and transactions
 * @param {string} [params.privateKey] wallet's private key
 * @param {string} [params.wif] wallet import format
 * @param {string} [params.host] host
 * @param {string} [params.contractAddress] the token contract address
 * @param {('nft-collection'|'nft-drop'|'edition-drop'|'token')} [params.contractType] the contract type
 * @param {('fungible_token_issuance'|'nft_extensible_mint'|'nft_multi_extensible_mint')} [params.tokenTemplate] the token template (use by Hamaza network)
 * @param {string} [params.recipientAddress] address to transfer the tokens to
 * @param {Amount} [params.quantity] number of tokens to transfer
 * @param {(NFTMetadataOrUri[]|NFTMetadataOrUri)} [params.metadata] token metadata
 * @param {string} [params.relayerUrl] relayer url (gasless transaction mode)
 * @return {(TransactionResult|TransactionResultWithId[]|string)} transaction id (Hazama) or transaction result (other networks)
 */
lib.mint = async ({network, signer, privateKey, wif, host, contractAddress, contractType, tokenTemplate, recipientAddress, quantity, metadata, relayerUrl}) => {
  try {
    if (!network) throw new Error(messages.NETWORK_UNDEFINED)

    return network !== 'hazama' ?
      await mintTokenOnEVMNetwork({network, signer, privateKey, contractAddress, contractType, recipientAddress, quantity, metadata, relayerUrl}) :
      await mintTokenOnHazamaNetwork({signer, wif, host, tokenTemplate, metadata})
  } catch (e) {
    lib.emit('error', e)
  }
}

/**
 * Transfer token on EVM network
 * 
 * @private
 * @param {object} params parameters for transfering token
 * @param {string} params.network the chain name or rpc url
 * @param {Signer} [params.signer] Signer to be used to sign messages and transactions
 * @param {string} [params.privateKey] wallet's private key
 * @param {string} params.contractAddress the token contract address
 * @param {('nft-collection'|'nft-drop'|'edition-drop'|'token')} params.contractType the contract type
 * @param {string} params.recipientAddress address to transfer the tokens to
 * @param {BigNumberish} [params.tokenId] token id
 * @param {Amount} [params.quantity] number of tokens to transfer
 * @param {string} [params.relayerUrl] relayer url (gasless transaction mode)
 * @return {Promise<TransactionResult>} promise
 */
async function transferTokenOnEVMNetwork({network, signer, privateKey, contractAddress, contractType, recipientAddress, tokenId, quantity, relayerUrl}) {
  return new Promise(async (resolve, reject) => {
    try {
      let result = null
      let contract = null
      let options = undefined

      if (!network) throw new Error(messages.NETWORK_UNDEFINED)

      if (!signer && !privateKey) throw new Error(messages.SIGNER_PRIVATEKEY_UNDEFINED)
    
      if (!contractAddress) throw new Error(messages.CONTRACT_ADDRESS_UNDEFINED)
    
      if (!recipientAddress) throw new Error(messages.RECIPIENT_ADDRESS_UNDEFINED)

      if (!contractType) throw new Error(messages.CONTRACT_TYPE_UNDEFINED)

      if (
        ![
          'nft-collection',
          'nft-drop',
          'edition-drop',
          'token'
        ].includes(contractType)
      )
        throw new Error(messages.CONTRACT_TYPE_IS_INVALID)
    
      if ([REMOTE_CONTRACT_TO_CONTRACT_TYPE.TokenERC721, REMOTE_CONTRACT_TO_CONTRACT_TYPE.DropERC721].includes(contractType) && !tokenId && tokenId !== 0) throw new Error(messages.TOKEN_ID_UNDEFINED)
    
      if (contractType === REMOTE_CONTRACT_TO_CONTRACT_TYPE.TokenERC20 && !quantity) throw new Error(messages.TOKEN_QUANTITY_UNDEFINED)
    
      if (contractType === REMOTE_CONTRACT_TO_CONTRACT_TYPE.DropERC1155 && (!quantity || (!tokenId && tokenId !== 0))) throw new Error(messages.BOTH_TOKEN_ID_AND_QUANTITY_ARE_REQUIRED)

      if (relayerUrl) {
        options = {
          gasless: {
            openzeppelin: {relayerUrl}
          }
        }         
      }

      let sdk = new ThirdwebSDK(network, options)

      if (signer) {
        sdk.updateSignerOrProvider(signer)
      }
    
      if (privateKey) {
        sdk = new ThirdwebSDK(
          new ethers.Wallet(
            privateKey,
            ethers.getDefaultProvider(getRpcUrlsByNetWork(network))
          )
        )
      }
    
      switch (contractType) {
        case REMOTE_CONTRACT_TO_CONTRACT_TYPE.TokenERC721:
          contract = sdk.getNFTCollection(contractAddress)
          result = await contract.transfer(recipientAddress, tokenId)
          break
        case REMOTE_CONTRACT_TO_CONTRACT_TYPE.DropERC721:
          contract = sdk.getNFTDrop(contractAddress)
          result = await contract.transfer(recipientAddress, tokenId)
          break
        case REMOTE_CONTRACT_TO_CONTRACT_TYPE.TokenERC20:
          contract = sdk.getToken(contractAddress)
          result = await contract.transfer(recipientAddress, quantity)
          break
        case REMOTE_CONTRACT_TO_CONTRACT_TYPE.DropERC1155:
          contract = sdk.getEditionDrop(contractAddress)
          result = await contract.transfer(recipientAddress, tokenId, quantity)
          break
        default:
          throw new Error (messages.TOKEN_TYPE_IS_NOT_SUPPORTED)
      }
      resolve(result)
    } catch (e) {
      reject(e)
    }
  })
}

/**
 * Transfer token on Hazama network
 * 
 * @private
 * @param {object} params parameters for transfering token
 * @param {Signer} [params.signer] Signer to be used to sign messages and transactions
 * @param {string} [params.wif] wallet import format
 * @param {string} params.host host
 * @param {('fungible_token_send'|'nft_send')} params.tokenTemplate the token template (use by Hamaza network)
 * @param {HazamaTransferTokenMetadata} params.metadata
 * @return {Promise<string>} promise
 */
async function transferTokenOnHazamaNetwork({signer, wif, host, tokenTemplate, metadata}) {
  return new Promise(async (resolve, reject) => {
    try {
      if (!signer && !wif) throw new Error(messages.SIGNER_WIF_UNDEFINED)
      
      if (!host) throw new Error(messages.HOST_UNDEFINED)

      if (!tokenTemplate) throw new Error(messages.TOKEN_TEMPLATE_UNDEFINED)
  
      if (!['fungible_token_send', 'nft_send'].includes(tokenTemplate)) throw new Error(messages.TOKEN_TEMPLATE_IS_INVALID)
  
      if (!metadata) throw new Error(messages.METADATA_UNDEFINED)
  
      if (!metadata.path) throw new Error(messages.TOKEN_PATH_UNDEFINED)

      if (!metadata.destination) throw new Error(messages.RECIPIENT_ADDRESS_UNDEFINED)
  
      if (tokenTemplate === 'fungible_token_send') {
        if (!metadata.amount) throw new Error(messages.TOKEN_QUANTITY_UNDEFINED)
      } else if (tokenTemplate === 'nft_send') {
        if (!metadata.name) throw new Error(messages.NFT_ID_QUANTITY_UNDEFINED)
      }
      let asm = await lib.template(tokenTemplate, metadata)
      const result = await compileAndBroadcast({host, asm, signer, wif})
      resolve(result)
    } catch (e) {
      reject(e)
    }
  })
}

/**
 * Transfer token (ERC20/ERC721/ERC1155)
 * @function
 * @name transferToken
 * @memberof hazama-lib/ERC20/ERC721/ERC1155
 * 
 * @example <caption>[Transfer ERC20 with privateKey on EVM network]</caption>
 * import hazlib from 'hazama-lib'
 * ...
 * const network = 'polygon'
 * const privateKey = 'dummy'
 * const contractAddress = '0x...'
 * const contractType = 'token'
 * const recipientAddress = '0x...'
 * const quantity = '0.8'
 * 
 * const result = hazlib.transferToken({ network, privateKey, contractAddress, contractType, recipientAddress, quantity })
 * ...
 * 
 * @example <caption>[Transfer ERC20 with signer and relayer on EVM network]</caption>
 * import hazlib from 'hazama-lib'
 * ...
 * const network = 'polygon'
 * const signer = <signer object>
 * const relayerUrl = 'https://api.defender.openzeppelin.com/autotasks/0f7cf308-.../runs/webhook/fd447953-...' // Openzeppelin webhook URI
 * const contractAddress = '0x...'
 * const contractType = 'token'
 * const recipientAddress = '0x...'
 * const quantity = '0.8'
 * 
 * const result = hazlib.transferToken({ network, signer, contractAddress, contractType, recipientAddress, quantity, relayerUrl })
 * ...
 * 
 * @example <caption>[Transfer ERC721 with privateKey on EVM network]</caption>
 * import hazlib from 'hazama-lib'
 * ...
 * const network = 'polygon'
 * const privateKey = 'dummy'
 * const contractAddress = '0x...'
 * const contractType = 'nft-collection'
 * const recipientAddress = '0x...'
 * const tokenId = 1
 * 
 * const result = hazlib.transferToken({ network, privateKey, contractAddress, contractType, recipientAddress, tokenId })
 * ...
 * 
 * @example <caption>[Transfer ERC721 with signer and relayer on EVM network]</caption>
 * import hazlib from 'hazama-lib'
 * ...
 * const network = 'polygon'
 * const signer = <signer object>
 * const relayerUrl = 'https://api.defender.openzeppelin.com/autotasks/0f7cf308-.../runs/webhook/fd447953-...' // Openzeppelin webhook URI
 * const contractAddress = '0x...'
 * const contractType = 'nft-collection'
 * const recipientAddress = '0x...'
 * const tokenId = 1
 * 
 * const result = hazlib.transferToken({ network, signer, contractAddress, contractType, recipientAddress, tokenId, relayerUrl })
 * ...
 * 
 * @example <caption>[Transfer DropERC721 with privateKey on EVM network]</caption>
 * import hazlib from 'hazama-lib'
 * ...
 * const network = 'polygon'
 * const privateKey = 'dummy'
 * const contractAddress = '0x...'
 * const contractType = 'nft-drop'
 * const recipientAddress = '0x...'
 * const tokenId = 1
 * 
 * const result = hazlib.transferToken({ network, privateKey, contractAddress, contractType, recipientAddress, tokenId })
 * ...
 * 
 * @example <caption>[Transfer DropERC721 with signer and relayer on EVM network]</caption>
 * import hazlib from 'hazama-lib'
 * ...
 * const network = 'polygon'
 * const signer = <signer object>
 * const relayerUrl = 'https://api.defender.openzeppelin.com/autotasks/0f7cf308-.../runs/webhook/fd447953-...' // Openzeppelin webhook URI
 * const contractAddress = '0x...'
 * const contractType = 'nft-drop'
 * const recipientAddress = '0x...'
 * const tokenId = 1
 * 
 * const result = hazlib.transferToken({ network, signer, contractAddress, contractType, recipientAddress, tokenId, relayerUrl })
 * ...
 * 
 * @example <caption>[Transfer DropERC1155 with privateKey on EVM network]</caption>
 * import hazlib from 'hazama-lib'
 * ...
 * const network = 'polygon'
 * const privateKey = 'dummy'
 * const contractAddress = '0x...'
 * const contractType = 'edition-drop'
 * const recipientAddress = '0x...'
 * const tokenId = 1
 * const quantity = '0.8'
 * 
 * const result = hazlib.transferToken({ network, privateKey, contractAddress, contractType, recipientAddress, tokenId, quantity })
 * ...
 * 
 * @example <caption>[Transfer DropERC1155 with signer and relayer on EVM network]</caption>
 * import hazlib from 'hazama-lib'
 * ...
 * const network = 'polygon'
 * const signer = <signer object>
 * const relayerUrl = 'https://api.defender.openzeppelin.com/autotasks/0f7cf308-.../runs/webhook/fd447953-...' // Openzeppelin webhook URI
 * const contractAddress = '0x...'
 * const contractType = 'edition-drop'
 * const recipientAddress = '0x...'
 * const tokenId = 1
 * const quantity = '0.8'
 * 
 * const result = hazlib.transferToken({ network, signer, contractAddress, contractType, recipientAddress, tokenId, quantity, relayerUrl })
 * ...
 * 
 * @example <caption>[Transfer fungible token on Hazama network]</caption>
 * import hazlib from 'hazama-lib'
 * ...
 * const network = 'hazama'
 * const wif = 'dummy'
 * const host = 'wss://n.hazama.io'
 * const tokenTemplate = 'fungible_token_send'
 * const metadata = {
 *  path: '/hazama/...'
 *  amount: '2000000000000000000',
 *  destination: '0x...',
 *  ...
 * }
 * 
 * const result = hazlib.transferToken({ network, wif, host, tokenTemplate, metadata })
 * ...
 * 
 * @example <caption>[Transfer NFT on Hazama network]</caption>
 * import hazlib from 'hazama-lib'
 * ...
 * const network = 'hazama'
 * const wif = 'dummy'
 * const host = 'wss://n.hazama.io'
 * const tokenTemplate = 'nft_send'
 * const metadata = {
 *  path: '/hazama/...'
 *  name: '2000000000000000000',  // idOrAmount
 *  destination: '0x...',
 *  ...
 * }
 * 
 * const result = hazlib.transferToken({ network, wif, host, tokenTemplate, metadata })
 * ...
 * 
 * @param {object} params parameters for transfering token
 * @param {string} params.network the chain name or rpc url
 * @param {Signer} [params.signer] Signer to be used to sign messages and transactions
 * @param {string} [params.privateKey] wallet's private key
 * @param {string} [params.wif] wallet import format
 * @param {string} [params.host] host
 * @param {string} [params.contractAddress] the token contract address
 * @param {('nft-collection'|'nft-drop'|'edition-drop'|'token')} [params.contractType] the contract type
 * @param {('fungible_token_send'|'nft_send')} [params.tokenTemplate] the token template (use by Hamaza network)
 * @param {string} [params.recipientAddress] address to transfer the tokens to
 * @param {BigNumberish} [params.tokenId] token id
 * @param {Amount} [params.quantity] number of tokens to transfer
 * @param {HazamaTransferTokenMetadata} [params.metadata] token metadata
 * @param {string} [params.relayerUrl] relayer url (gasless transaction mode)
 * @return {TransactionResult|string} transaction id (Hazama) or transaction result
 */
lib.transferToken = async ({network, signer, privateKey, wif, host, contractAddress, contractType, tokenTemplate, recipientAddress, tokenId, quantity, metadata, relayerUrl}) => {
  try {
    if (!network) throw new Error(messages.NETWORK_UNDEFINED)

    return network !== 'hazama' ?
      await transferTokenOnEVMNetwork({network, signer, privateKey, contractAddress, contractType, recipientAddress, tokenId, quantity, relayerUrl}) :
      await transferTokenOnHazamaNetwork({signer, wif, host, tokenTemplate, metadata})
  } catch (e) {
    lib.emit('error', e)
  }
}

/**
 * Set claim conditions on EVM Network
 * 
 * @private
 * @param {object} params parameters for setting claim conditions
 * @param {string} params.network the chain name or rpc url
 * @param {Signer} [params.signer] Signer to be used to sign messages and transactions.<br/>If private key is not set, Signer is required.
 * @param {string} [params.privateKey] wallet's private key.<br/>If Signer is not set, private key is required.
 * @param {string} params.contractAddress the token contract address
 * @param {('nft-drop'|'edition-drop')} params.contractType the contract type
 * @param {BigNumberish} [params.tokenId] token id
 * @param {ClaimConditionInput[]} params.claimConditions claim conditions
 * @param {string} [params.relayerUrl] relayer url (gasless transaction mode)
 * @return {Promise<TransactionResult>} promise
 */
async function setClaimConditionsOnEVMNetwork({network, signer, privateKey, contractAddress, contractType, tokenId, claimConditions, relayerUrl}) {
  return new Promise(async (resolve, reject) => {
    try {
      let contract = null
      let result = null
      let options = undefined

      if (!network) throw new Error(messages.NETWORK_UNDEFINED)
    
      if (!signer && !privateKey) throw new Error(messages.SIGNER_PRIVATEKEY_UNDEFINED)
    
      if (!contractType) throw new Error(messages.CONTRACT_TYPE_UNDEFINED)
    
      if (
        ![
          'nft-drop',
          'edition-drop'
        ].includes(contractType)
      )
        throw new Error(messages.CONTRACT_TYPE_IS_INVALID)

      if (!claimConditions) throw new Error(messages.CLAIM_CONDITIONS_UNDEFINED)

      if (contractType === REMOTE_CONTRACT_TO_CONTRACT_TYPE.DropERC1155 && !tokenId && tokenId !== 0) throw new Error(messages.TOKEN_ID_UNDEFINED)

      if (relayerUrl) {
        options = {
          gasless: {
            openzeppelin: {relayerUrl}
          }
        }         
      }

      let sdk = new ThirdwebSDK(network, options)
    
      if (signer) {
        sdk.updateSignerOrProvider(signer)
      }
    
      if (privateKey) {
        sdk = new ThirdwebSDK(
          new ethers.Wallet(
            privateKey,
            ethers.getDefaultProvider(getRpcUrlsByNetWork(network))
          )
        )
      }
    
      switch (contractType) {
        case REMOTE_CONTRACT_TO_CONTRACT_TYPE.DropERC1155:
          contract = sdk.getEditionDrop(contractAddress)
          result = await contract.claimConditions.set(tokenId, claimConditions)
          break
        case REMOTE_CONTRACT_TO_CONTRACT_TYPE.DropERC721:
          contract = sdk.getNFTDrop(contractAddress)
          result = await contract.claimConditions.set(claimConditions)
          break
        default:
          throw new Error (messages.TOKEN_TYPE_IS_NOT_SUPPORTED)
      }
      resolve(result)
    } catch (e) {
      reject(e)
    }
  })
}

/**
 * Set claim conditions on Hazama Network
 * 
 * @private
 * @param {object} params parameters for setting claim conditions
 * @param {Signer} [params.signer] Signer to be used to sign messages and transactions.<br/>If wif is not set, Signer is required.
 * @param {string} [params.wif] wallet import format.<br/>If Signer is not set, wif is required.
 * @param {string} params.host host
 * @param {('nft_set_claim_conditions')} params.tokenTemplate the token template
 * @param {HazamaClaimConditionInput} params.claimConditions claim conditions
 * @return {Promise<string>} promise
 */
async function setClaimConditionsOnHazamaNetwork({signer, wif, host, tokenTemplate, claimConditions}) {
  return new Promise(async (resolve, reject) => {
    try {
      if (!signer && !wif) throw new Error(messages.SIGNER_WIF_UNDEFINED)
      
      if (!host) throw new Error(messages.HOST_UNDEFINED)
  
      if (!tokenTemplate) throw new Error(messages.TOKEN_TEMPLATE_UNDEFINED)
  
      if (!['nft_set_claim_conditions'].includes(tokenTemplate)) throw new Error(messages.TOKEN_TEMPLATE_IS_INVALID)
  
      if (!claimConditions) throw new Error(messages.CLAIM_CONDITIONS_UNDEFINED)
  
      if (!claimConditions.path) throw new Error(messages.CONTRACT_PATH_UNDEFINED)
  
      if (!claimConditions.token && claimConditions.token !== 0) throw new Error(messages.TOKEN_ID_UNDEFINED)

      let asm = await lib.template(tokenTemplate, claimConditions)
      const result = await compileAndBroadcast({host, asm, signer, wif})
      resolve(result)
    } catch (e) {
      reject(e)
    }
  })
}

/**
 * Set claim conditions for DropERC721/DropERC1155
 * @function
 * @name setClaimConditions
 * @memberof hazama-lib/ERC20/ERC721/ERC1155
 * 
 * @example <caption>[Set claim conditions for DropERC721 with privateKey on EVM network]</caption>
 * import hazlib from 'hazama-lib'
 * ...
 * const network = 'polygon'
 * const privateKey = 'dummy'
 * const contractAddress = '0x...'
 * const contractType = 'nft-drop'
 * const claimConditions = [{
 *  startTime: new Date(),
 *  maxQuantity: 2,
 *  ...
 * }]
 * 
 * const result = hazlib.setClaimConditions({ network, privateKey, contractAddress, contractType, claimConditions })
 * ...
 * 
 * @example <caption>[Set claim conditions for DropERC721 with signer and relayer on EVM network]</caption>
 * import hazlib from 'hazama-lib'
 * ...
 * const network = 'polygon'
 * const signer = <signer object>
 * const relayerUrl = 'https://api.defender.openzeppelin.com/autotasks/0f7cf308-.../runs/webhook/fd447953-...' // Openzeppelin webhook URI
 * const contractAddress = '0x...'
 * const contractType = 'nft-drop'
 * const claimConditions = [{
 *  startTime: new Date(),
 *  maxQuantity: 2,
 *  ...
 * }]
 * 
 * const result = hazlib.setClaimConditions({ network, signer, contractAddress, contractType, claimConditions, relayerUrl })
 * ...
 * 
 * @example <caption>[Set claim conditions for DropERC1155 with privateKey on EVM network]</caption>
 * import hazlib from 'hazama-lib'
 * ...
 * const network = 'polygon'
 * const privateKey = 'dummy'
 * const contractAddress = '0x...'
 * const contractType = 'edition-drop'
 * const tokenId = 1
 * const claimConditions = [{
 *  startTime: new Date(),
 *  maxQuantity: 2,
 *  ...
 * }]
 * 
 * const result = hazlib.setClaimConditions({ network, privateKey, contractAddress, contractType, tokenId, claimConditions })
 * ...
 * 
 * @example <caption>[Set claim conditions for DropERC1155 with signer and relayer on EVM network]</caption>
 * import hazlib from 'hazama-lib'
 * ...
 * const network = 'polygon'
 * const signer = <signer object>
 * const relayerUrl = 'https://api.defender.openzeppelin.com/autotasks/0f7cf308-.../runs/webhook/fd447953-...' // Openzeppelin webhook URI
 * const contractAddress = '0x...'
 * const contractType = 'edition-drop'
 * const tokenId = 1
 * const claimConditions = [{
 *  startTime: new Date(),
 *  maxQuantity: 2,
 *  ...
 * }]
 * 
 * const result = hazlib.setClaimConditions({ network, signer, contractAddress, contractType, tokenId, claimConditions, relayerUrl })
 * ...
 * 
 * @example <caption>[Set claim conditions for NFT on Hazama network]</caption>
 * import hazlib from 'hazama-lib'
 * ...
 * const network = 'hazama'
 * const wif = 'dummy'
 * const host = 'wss://n.hazama.io'
 * const tokenTemplate = 'nft_set_claim_conditions'
 * const claimConditions = {
 *  path: '/hazama/...',
 *  token: 1,
 *  startTime: new Date(),
 *  maxQuantity: 1,
 *  ...
 * }
 * 
 * const result = hazlib.setClaimConditions({ network, wif, host, tokenTemplate, claimConditions })
 * ...
 * 
 * @param {object} params parameters for setting claim conditions
 * @param {string} params.network the chain name or rpc url
 * @param {Signer} [params.signer] Signer to be used to sign messages and transactions
 * @param {string} [params.privateKey] wallet's private key
 * @param {string} [params.wif] wallet import format
 * @param {string} [params.host] host
 * @param {string} [params.contractAddress] the token contract address
 * @param {('nft-drop'|'edition-drop')} [params.contractType] the contract type
 * @param {('nft_set_claim_conditions')} [params.tokenTemplate] the token template (use by Hamaza network)
 * @param {BigNumberish} [params.tokenId] token id
 * @param {ClaimConditionInput[]|HazamaClaimConditionInput} params.claimConditions claim conditions
 * @param {string} [params.relayerUrl] relayer url (gasless transaction mode)
 * @return {TransactionResult|string} transaction id (Hazama) or transaction result
 */
lib.setClaimConditions = async ({network, signer, privateKey, wif, host, contractAddress, contractType, tokenTemplate, tokenId, claimConditions, relayerUrl}) => {
  try {
    if (!network) throw new Error(messages.NETWORK_UNDEFINED)

    return network !== 'hazama' ?
      await setClaimConditionsOnEVMNetwork({network, signer, privateKey, contractAddress, contractType, tokenId, claimConditions, relayerUrl}) :
      await setClaimConditionsOnHazamaNetwork({signer, wif, host, tokenTemplate, claimConditions})
  } catch (e) {
    lib.emit('error', e)
  }
}

/**
 * Claim on EVM Network
 * 
 * @private
 * @param {object} params parameters for claiming
 * @param {string} params.network the chain name or rpc url
 * @param {Signer} [params.signer] Signer to be used to sign messages and transactions.<br/>If private key is not set, Signer is required.
 * @param {string} [params.privateKey] wallet's private key.<br/>If Signer is not set, private key is required.
 * @param {string} params.contractAddress the token contract address
 * @param {('nft-drop'|'edition-drop')} params.contractType the contract type
 * @param {string} params.recipientAddress address to transfer the tokens to
 * @param {BigNumberish} [params.tokenId] token id
 * @param {Amount} params.quantity number of tokens to transfer
 * @param {string} [params.relayerUrl] relayer url (gasless transaction mode)
 * @return {Promise<TransactionResult>} promise
 */
async function claimOnEVMNetwork({network, signer, privateKey, contractAddress, contractType, recipientAddress, tokenId, quantity, relayerUrl}) {
  return new Promise(async (resolve, reject) => {
    try {
      let result = null
      let contract = null
      let options = undefined

      if (!network) throw new Error(messages.NETWORK_UNDEFINED)

      if (!signer && !privateKey) throw new Error(messages.SIGNER_PRIVATEKEY_UNDEFINED)
    
      if (!contractAddress) throw new Error(messages.CONTRACT_ADDRESS_UNDEFINED)
    
      if (!recipientAddress) throw new Error(messages.RECIPIENT_ADDRESS_UNDEFINED)

      if (!quantity) throw new Error(messages.TOKEN_QUANTITY_UNDEFINED)

      if (!contractType) throw new Error(messages.CONTRACT_TYPE_UNDEFINED)

      if (
        ![
          'nft-drop',
          'edition-drop',
        ].includes(contractType)
      )
        throw new Error(messages.CONTRACT_TYPE_IS_INVALID)
    
      if (contractType === REMOTE_CONTRACT_TO_CONTRACT_TYPE.DropERC1155 && !tokenId && tokenId !== 0) throw new Error(messages.TOKEN_ID_UNDEFINED)

      if (relayerUrl) {
        options = {
          gasless: {
            openzeppelin: {relayerUrl}
          }
        }         
      }

      let sdk = new ThirdwebSDK(network, options)
      if (signer) {
        sdk.updateSignerOrProvider(signer)
      }
    
      if (privateKey) {
        sdk = new ThirdwebSDK(
          new ethers.Wallet(
            privateKey,
            ethers.getDefaultProvider(getRpcUrlsByNetWork(network))
          )
        )
      }
    
      switch (contractType) {
        case REMOTE_CONTRACT_TO_CONTRACT_TYPE.DropERC721:
          contract = sdk.getNFTDrop(contractAddress)
          result = await contract.claimTo(recipientAddress, quantity)
          break
        case REMOTE_CONTRACT_TO_CONTRACT_TYPE.DropERC1155:
          contract = sdk.getEditionDrop(contractAddress)
          result = await contract.claimTo(recipientAddress, tokenId, quantity)
          break
        default:
          throw new Error (messages.TOKEN_TYPE_IS_NOT_SUPPORTED)
      }
      resolve(result)
    } catch (e) {
      reject(e)
    }
  })
}

/**
 * Claim on Hazama Network
 * 
 * @private
 * @param {object} params parameters for claiming
 * @param {Signer} [params.signer] Signer to be used to sign messages and transactions.<br/>If wif is not set, Signer is required.
 * @param {string} [params.wif] wallet import format.<br/>If Signer is not set, wif is required.
 * @param {string} params.host host
 * @param {('nft_claimto')} params.tokenTemplate the token template (use by Hamaza network)
 * @param {HazamaClaimMetadata} params.metadata claim metadata
 * @return {Promise<string>} transaction id (Hazama) or transaction result
 */
async function claimOnHazamaNetwork({signer, wif, host, tokenTemplate, metadata}) {
  return new Promise(async (resolve, reject) => {
    try {
      if (!signer && !wif) throw new Error(messages.SIGNER_WIF_UNDEFINED)
      
      if (!host) throw new Error(messages.HOST_UNDEFINED)

      if (!tokenTemplate) throw new Error(messages.TOKEN_TEMPLATE_UNDEFINED)
  
      if (!['nft_claimto'].includes(tokenTemplate)) throw new Error(messages.TOKEN_TEMPLATE_IS_INVALID)
  
      if (!metadata) throw new Error(messages.METADATA_UNDEFINED)
  
      if (!metadata.path) throw new Error(messages.TOKEN_PATH_UNDEFINED)

      if (!metadata.address) throw new Error(messages.RECIPIENT_ADDRESS_UNDEFINED)

      if (!metadata.amount) throw new Error(messages.TOKEN_QUANTITY_UNDEFINED)

      if (!metadata.token && metadata.token !== 0) throw new Error(messages.TOKEN_ID_UNDEFINED)

      let asm = await lib.template(tokenTemplate, metadata)
      const result = await compileAndBroadcast({host, asm, signer, wif})
      resolve(result)
    } catch (e) {
      reject(e)
    }
  })
}

/**
 * Claim DropERC721/DropERC1155
 * @function
 * @name claim
 * @memberof hazama-lib/ERC20/ERC721/ERC1155
 * 
 * @example <caption>[Claim DropERC721 with privateKey on EVM network]</caption>
 * import hazlib from 'hazama-lib'
 * ...
 * const network = 'polygon'
 * const privateKey = 'dummy'
 * const contractAddress = '0x...'
 * const contractType = 'nft-drop'
 * const recipientAddress = '0x...'
 * const quantity = 2
 * 
 * const result = hazlib.claim({ network, privateKey, contractAddress, contractType, recipientAddress, quantity })
 * ...
 * 
 * @example <caption>[Claim DropERC721 with signer and relayer on EVM network]</caption>
 * import hazlib from 'hazama-lib'
 * ...
 * const network = 'polygon'
 * const signer = <signer object>
 * const relayerUrl = 'https://api.defender.openzeppelin.com/autotasks/0f7cf308-.../runs/webhook/fd447953-...' // Openzeppelin webhook URI
 * const contractAddress = '0x...'
 * const contractType = 'nft-drop'
 * const recipientAddress = '0x...'
 * const quantity = 2
 * 
 * const result = hazlib.claim({ network, signer, contractAddress, contractType, recipientAddress, quantity, relayerUrl })
 * ...
 * 
 * @example <caption>[Claim DropERC1155 with privateKey on EVM network]</caption>
 * import hazlib from 'hazama-lib'
 * ...
 * const network = 'polygon'
 * const privateKey = 'dummy'
 * const contractAddress = '0x...'
 * const contractType = 'edition-drop'
 * const recipientAddress = '0x...'
 * const tokenId = 1
 * const quantity = 2
 * 
 * const result = hazlib.claim({ network, privateKey, contractAddress, contractType, recipientAddress, tokenId, quantity })
 * ...
 * 
 * @example <caption>[Claim DropERC1155 with signer and relayer on EVM network]</caption>
 * import hazlib from 'hazama-lib'
 * ...
 * const network = 'polygon'
 * const signer = <signer object>
 * const relayerUrl = 'https://api.defender.openzeppelin.com/autotasks/0f7cf308-.../runs/webhook/fd447953-...' // Openzeppelin webhook URI
 * const contractAddress = '0x...'
 * const contractType = 'edition-drop'
 * const recipientAddress = '0x...'
 * const tokenId = 1
 * const quantity = 2
 * 
 * const result = hazlib.claim({ network, signer, contractAddress, contractType, recipientAddress, tokenId, quantity, relayerUrl })
 * ...
 * 
 * @example <caption>[Claim NFT on Hazama network]</caption>
 * import hazlib from 'hazama-lib'
 * ...
 * const network = 'hazama'
 * const wif = 'dummy'
 * const host = 'wss://n.hazama.io'
 * const tokenTemplate = 'nft_claimto'
 * const metadata = {
 *  path: '/hazama/...'
 *  amount: 1,
 *  address: '0x...',
 *  token: 1
 * }
 * 
 * const result = hazlib.claim({ network, wif, host, tokenTemplate, metadata })
 * ...
 * 
 * @param {object} params parameters for claiming
 * @param {string} params.network the chain name or rpc url
 * @param {Signer} [params.signer] Signer to be used to sign messages and transactions
 * @param {string} [params.privateKey] wallet's private key
 * @param {string} [params.wif] wallet import format
 * @param {string} [params.host] host
 * @param {string} [params.contractAddress] the token contract address
 * @param {('nft-drop'|'edition-drop')} [params.contractType] the contract type
 * @param {('nft_claimto')} [params.tokenTemplate] the token template (use by Hamaza network)
 * @param {string} [params.recipientAddress] address to transfer the tokens to
 * @param {BigNumberish} [params.tokenId] token id
 * @param {Amount} [params.quantity] number of tokens to transfer
 * @param {HazamaClaimMetadata} [params.metadata] claim metadata
 * @param {string} [params.relayerUrl] relayer url (gasless transaction mode)
 * @return {TransactionResult|string} transaction id (Hazama) or transaction result
 */
lib.claim = async ({network, signer, privateKey, wif, host, contractAddress, contractType, tokenTemplate, recipientAddress, tokenId, quantity, metadata, relayerUrl}) => {
  try {
    if (!network) throw new Error(messages.NETWORK_UNDEFINED)
    
    return network !== 'hazama' ?
      await claimOnEVMNetwork({network, signer, privateKey, contractAddress, contractType, recipientAddress, tokenId, quantity, relayerUrl}) :
      await claimOnHazamaNetwork({signer, wif, host, tokenTemplate, metadata})
  } catch (e) {
    lib.emit('error', e)
  }
}

/**
 * grant roles on EVM Network
 * 
 * @private
 * @param {object} params parameters for granting roles
 * @param {string} params.network the chain name or rpc url
 * @param {Signer} [params.signer] Signer to be used to sign messages and transactions
 * @param {string} [params.privateKey] wallet's private key
 * @param {string} params.contractAddress the token contract address
 * @param {RolesObject} params.roles roles of contract
 * @param {string} [params.relayerUrl] relayer url (gasless transaction mode)
 * @return {Promise<TransactionResult[]>} promise
 */
async function grantRolesOnEVMNetwork({network, signer, privateKey, contractAddress, roles, relayerUrl}) {
  return new Promise(async (resolve, reject) => {
    try {
      let contract = null
      let options = undefined

      if (!roles) throw new Error(messages.ROLES_UNDEFINED)

      if (!signer && !privateKey) throw new Error(messages.SIGNER_PRIVATEKEY_UNDEFINED)
    
      if (!contractAddress) throw new Error(messages.CONTRACT_ADDRESS_UNDEFINED)

      if (!ethers.utils.isAddress(contractAddress)) throw new Error(messages.CONTRACT_ADDRESS_INVALID)
      
      let rolesArr = []
      
      
      Object.keys(roles).forEach(roleName => {
        if (!['admin', 'minter', 'transfer'].includes(roleName)) {
          return
        }

        const addressByRoleName = roles[roleName]

        addressByRoleName.forEach(address => {
          if (!ethers.utils.isAddress(address)) throw new Error(messages.ROLE_CONTRACT_ADDRESS_INVALID)

          rolesArr.push({
            name: roleName,
            address,
          })
        })
      })

      if (relayerUrl) {
        options = {
          gasless: {
            openzeppelin: {relayerUrl}
          }
        }         
      }

      let sdk = new ThirdwebSDK(network, options)
      if (signer) {
        sdk.updateSignerOrProvider(signer)
      }
    
      if (privateKey) {
        sdk = new ThirdwebSDK(
          new ethers.Wallet(
            privateKey,
            ethers.getDefaultProvider(getRpcUrlsByNetWork(network))
          )
        )
      }

      const contractType = await sdk.resolveContractType(contractAddress)
      if (
        ![
          REMOTE_CONTRACT_TO_CONTRACT_TYPE.DropERC721,
          REMOTE_CONTRACT_TO_CONTRACT_TYPE.TokenERC721,
          REMOTE_CONTRACT_TO_CONTRACT_TYPE.DropERC1155,
          REMOTE_CONTRACT_TO_CONTRACT_TYPE.TokenERC20,
          REMOTE_CONTRACT_TO_CONTRACT_TYPE.Multiwrap,
        ].includes(contractType)
      )
        throw new Error(messages.CONTRACT_TYPE_IS_INVALID)
    
      switch (contractType) {
        case REMOTE_CONTRACT_TO_CONTRACT_TYPE.DropERC721:
          contract = sdk.getNFTDrop(contractAddress)
          break
        case REMOTE_CONTRACT_TO_CONTRACT_TYPE.TokenERC721:
          contract = sdk.getNFTCollection(contractAddress)
          break
        case REMOTE_CONTRACT_TO_CONTRACT_TYPE.DropERC1155:
          contract = sdk.getEditionDrop(contractAddress)
          break
        case REMOTE_CONTRACT_TO_CONTRACT_TYPE.TokenERC20:
          contract = sdk.getToken(contractAddress)
          break
        case REMOTE_CONTRACT_TO_CONTRACT_TYPE.Multiwrap:
          contract = sdk.getMultiwrap(contractAddress)
          break
        default:
          throw new Error (messages.TOKEN_TYPE_IS_NOT_SUPPORTED)
      }

      const results = []
      for (let index = 0; index < rolesArr.length; index++) {
        const { name, address } = rolesArr[index]

        const role = await contract.roles.get(name)

        if (role.includes(address) || (name === 'transfer' && role.includes(ethers.constants.AddressZero))) {
          continue
        }

        const result = await contract.roles.grant(name, address)
        results.push(result)
      }

      resolve(results)
    } catch (e) {
      reject(e)
    }
  })
}

/**
 * Add permissions<br/><br/>
 * Important Note:
 * 1. If wallet address exists in role, it will be skipped
 * 2. If zero address(0x0000000000000000000000000000000000000000) exists in role, all wallet address of role will be skipped
 * @function
 * @name addPermissions
 * @memberof hazama-lib/ERC20/ERC721/ERC1155
 * 
 * @example <caption>[add permissions with privateKey on EVM network]</caption>
 * import hazlib from 'hazama-lib'
 * ...
 * const network = 'polygon'
 * const privateKey = 'dummy'
 * const contractAddress = '0x...'
 * const roles = {
 *   admin: ["0x..."],
 *   minter: ["0x..."],
 *   transfer: ["0x..."],
 * }
 * 
 * const result = hazlib.addPermissions({ network, privateKey, contractAddress, roles })
 * ...
 * 
 * @example <caption>[add permissions with signer and relayer on EVM network]</caption>
 * import hazlib from 'hazama-lib'
 * ...
 * const network = 'polygon'
 * const signer = <signer object>
 * const relayerUrl = 'https://api.defender.openzeppelin.com/autotasks/0f7cf308-.../runs/webhook/fd447953-...' // Openzeppelin webhook URI
 * const contractAddress = '0x...'
 * const roles = {
 *   admin: ["0x..."],
 *   minter: ["0x..."],
 *   transfer: ["0x..."],
 * }
 * 
 * const result = hazlib.addPermissions({ network, signer, contractAddress, roles, relayerUrl })
 * ...
 * 
 * @param {object} params parameters for adding permissions
 * @param {string} params.network the chain name or rpc url
 * @param {Signer} [params.signer] Signer to be used to sign messages and transactions
 * @param {string} [params.privateKey] wallet's private key
 * @param {string} params.contractAddress the token contract address
 * @param {RolesObject} params.roles roles of contract
 * @param {string} [params.relayerUrl] relayer url (gasless transaction mode)
 * @return {TransactionResult[]} transaction id (Hazama) or transaction result
 */
lib.addPermissions = async ({network, signer, privateKey, contractAddress, roles, relayerUrl}) => {
  try {
    if (!network) throw new Error(messages.NETWORK_UNDEFINED)

    if (network === 'hazama') throw new Error(messages.NETWORK_IS_NOT_SUPPORTED)

    const result = await grantRolesOnEVMNetwork({network, signer, privateKey, contractAddress, roles, relayerUrl})

    return result
  } catch (e) {
    lib.emit('error', e)
  }
}

/**
 * revoke roles on EVM Network
 * 
 * @private
 * @param {object} params parameters for revoking roles
 * @param {string} params.network the chain name or rpc url
 * @param {Signer} [params.signer] Signer to be used to sign messages and transactions
 * @param {string} [params.privateKey] wallet's private key
 * @param {string} params.contractAddress the token contract address
 * @param {RolesObject} params.roles roles of contract
 * @param {string} [params.relayerUrl] relayer url (gasless transaction mode)
 * @return {Promise<TransactionResult[]>} promise
 */
async function revokeRolesOnEVMNetwork({network, signer, privateKey, contractAddress, roles, relayerUrl}) {
  return new Promise(async (resolve, reject) => {
    try {
      let contract = null
      let options = undefined

      if (!roles) throw new Error(messages.ROLES_UNDEFINED)

      if (!signer && !privateKey) throw new Error(messages.SIGNER_PRIVATEKEY_UNDEFINED)
    
      if (!contractAddress) throw new Error(messages.CONTRACT_ADDRESS_UNDEFINED)

      if (!ethers.utils.isAddress(contractAddress)) throw new Error(messages.CONTRACT_ADDRESS_INVALID)
      
      let rolesArr = []
      
      
      Object.keys(roles).forEach(roleName => {
        if (!['admin', 'minter', 'transfer'].includes(roleName)) {
          return
        }

        const addressByRoleName = roles[roleName]

        addressByRoleName.forEach(address => {
          // if (!ethers.utils.isAddress(address)) throw new Error(messages.ROLE_CONTRACT_ADDRESS_INVALID)

          rolesArr.push({
            name: roleName,
            address,
          })
        })
      })

      if (relayerUrl) {
        options = {
          gasless: {
            openzeppelin: {relayerUrl}
          }
        }         
      }

      let sdk = new ThirdwebSDK(network, options)
      if (signer) {
        sdk.updateSignerOrProvider(signer)
      }
    
      if (privateKey) {
        sdk = new ThirdwebSDK(
          new ethers.Wallet(
            privateKey,
            ethers.getDefaultProvider(getRpcUrlsByNetWork(network))
          )
        )
      }

      const contractType = await sdk.resolveContractType(contractAddress)
      if (
        ![
          REMOTE_CONTRACT_TO_CONTRACT_TYPE.DropERC721,
          REMOTE_CONTRACT_TO_CONTRACT_TYPE.TokenERC721,
          REMOTE_CONTRACT_TO_CONTRACT_TYPE.DropERC1155,
          REMOTE_CONTRACT_TO_CONTRACT_TYPE.TokenERC20,
          REMOTE_CONTRACT_TO_CONTRACT_TYPE.Multiwrap,
        ].includes(contractType)
      )
        throw new Error(messages.CONTRACT_TYPE_IS_INVALID)
    
      switch (contractType) {
        case REMOTE_CONTRACT_TO_CONTRACT_TYPE.DropERC721:
          contract = sdk.getNFTDrop(contractAddress)
          break
        case REMOTE_CONTRACT_TO_CONTRACT_TYPE.TokenERC721:
          contract = sdk.getNFTCollection(contractAddress)
          break
        case REMOTE_CONTRACT_TO_CONTRACT_TYPE.DropERC1155:
          contract = sdk.getEditionDrop(contractAddress)
          break
        case REMOTE_CONTRACT_TO_CONTRACT_TYPE.TokenERC20:
          contract = sdk.getToken(contractAddress)
          break
        case REMOTE_CONTRACT_TO_CONTRACT_TYPE.Multiwrap:
          contract = sdk.getMultiwrap(contractAddress)
          break
        default:
          throw new Error (messages.TOKEN_TYPE_IS_NOT_SUPPORTED)
      }

      const results = []
      for (let index = 0; index < rolesArr.length; index++) {
        const { name, address } = rolesArr[index]

        const role = await contract.roles.get(name)

        if (!role.includes(address)) {
          continue
        }

        const result = await contract.roles.revoke(name, address)
        results.push(result)
      }

      resolve(results)
    } catch (e) {
      reject(e)
    }
  })
}

/**
 * Remove permissions<br/><br/>
 * @function
 * @name removePermissions
 * @memberof hazama-lib/ERC20/ERC721/ERC1155
 * 
 * @example <caption>[remove permissions with privateKey on EVM network]</caption>
 * import hazlib from 'hazama-lib'
 * ...
 * const network = 'polygon'
 * const privateKey = 'dummy'
 * const contractAddress = '0x...'
 * const roles = {
 *   admin: ["0x..."],
 *   minter: ["0x..."],
 *   transfer: ["0x..."],
 * }
 * 
 * const result = hazlib.removePermissions({ network, privateKey, contractAddress, roles })
 * ...
 * 
 * @example <caption>[remove permissions with signer and relayer on EVM network]</caption>
 * import hazlib from 'hazama-lib'
 * ...
 * const network = 'polygon'
 * const signer = <signer object>
 * const relayerUrl = 'https://api.defender.openzeppelin.com/autotasks/0f7cf308-.../runs/webhook/fd447953-...' // Openzeppelin webhook URI
 * const contractAddress = '0x...'
 * const roles = {
 *   admin: ["0x..."],
 *   minter: ["0x..."],
 *   transfer: ["0x..."],
 * }
 * 
 * const result = hazlib.removePermissions({ network, signer, contractAddress, roles, relayerUrl })
 * ...
 * 
 * @param {object} params parameters for removing permissions
 * @param {string} params.network the chain name or rpc url
 * @param {Signer} [params.signer] Signer to be used to sign messages and transactions
 * @param {string} [params.privateKey] wallet's private key
 * @param {string} params.contractAddress the token contract address
 * @param {RolesObject} params.roles roles of contract
 * @param {string} [params.relayerUrl] relayer url (gasless transaction mode)
 * @return {TransactionResult[]} transaction id (Hazama) or transaction result
 */
lib.removePermissions = async ({network, signer, privateKey, contractAddress, roles, relayerUrl}) => {
  try {
    if (!network) throw new Error(messages.NETWORK_UNDEFINED)

    if (network === 'hazama') throw new Error(messages.NETWORK_IS_NOT_SUPPORTED)

    const result = await revokeRolesOnEVMNetwork({network, signer, privateKey, contractAddress, roles, relayerUrl})

    return result
  } catch (e) {
    lib.emit('error', e)
  }
}

module.exports = lib
